<!--
 * @Author: JakeChiu
 * @Email: zhaokai@staff.hexun.com
 * @GitHub: https://github.com/zhakei988
 * @Date: 2025-12-24 09:54:25
 * @LastEditTime: 2026-01-23 19:19:25
 * @Description: JakeChiu`s hxteam
 * @FilePath: \visualh5\src\App.vue
-->
<template>
  <div id="app">
    <loginfordy v-if="isloaddysdk" ref="dysdk"></loginfordy>
    <micropaymentCom ref="micropaymentcom"></micropaymentCom>
    <div
      class="main"
      v-if="modelist.length > 0"
      @scroll="mainscroll"
      @click="isshowstock = false"
    >
      <div
        v-for="(item, index) in modelist"
        :key="index"
        class="item"
        :id="item.id"
        :style="getsit(item)"
        @click="evenclick(item)"
      >
        <div v-if="item.type === 'pic'" class="pic">
          <img :src="item.src" class="img" />
        </div>
        <div
          v-if="
            item.type === 'link' &&
            item.forcePay &&
            modeopt?.payMentType == 'h5RefundWithoutLogin' &&
            showPaySuccess
          "
          class="link"
        >
          <p>正在查询支付信息</p>
          <p>马上跳转...</p>
        </div>
        <div v-if="item.type === 'phone'" class="phone">
          <div class="pho_x1 phoneitem">
            <div class="n">手机号</div>
            <input
              @focus="scollandroidsit($event)"
              type="number"
              v-model="phonenumber"
              value=""
              placeholder="请输入手机号码"
              pattern="[0-9]*"
            />
          </div>
          <div class="pho_x3 phoneitem" v-if="edunstate == 2">
            <input
              type="text"
              @focus="scollandroidsit($event)"
              v-model="phoneimgcode"
              placeholder="输入右侧图形码"
            />
            <div class="n">
              <img @click="getimgcode" :src="phoneimgcodesrc" />
            </div>
          </div>
          <div class="pho_x2 phoneitem">
            <input
              @focus="scollandroidsit($event)"
              type="number"
              v-model="phonecode"
              pattern="[0-9]*"
              placeholder="输入手机验证码"
            />
            <div
              class="n"
              @click="getphonecode()"
              v-html="
                cdnum > 0
                  ? `<span class='red'>${cdnum}s</span>后重发`
                  : '获取验证码'
              "
            ></div>
          </div>
          <div class="pho_x4" @click="getphonesubclick(item)">
            <img :src="item.src" />
          </div>
          <div class="pho_x5" v-if="!item.phocheckagreement">
            <label
              ><input
                type="checkbox"
                v-model="phonecheckbox"
              />勾选即代表您已经阅读并同意</label
            ><a href="https://caidao.homeway.com.cn/xy/xz.html">用户协议</a>和<a
              href="https://caidao.homeway.com.cn/xy/cdxy.html"
              >服务协议</a
            >
          </div>
        </div>
        <div v-if="item.type === 'stock'" class="stock">
          <div
            :class="[
              'stocklay',
              stockdetail.length > 0
                ? isstockup
                  ? 'stockup'
                  : 'stockdown'
                : '',
            ]"
            :style="`background-image:url(${item.src})`"
          >
            <div class="sx_1">
              <div class="inpt">
                <div
                  id="floattest"
                  style="
                    top: -148px;
                    left: 0px;
                    position: absolute;
                    display: none;
                  "
                >
                  <div>stockinput距离顶部位置：{{ testscroll.stockinput }}</div>
                  <div>body可视高度：{{ testscroll.bodyheight }}</div>
                  <div>搜索结果：{{ JSON.stringify(stockdetail) }}</div>
                </div>
                <input
                  oninput="if(value.length>6)value=value.slice(0,6)"
                  @keyup="stockinputkeyup"
                  @blur="stockinputblur"
                  @focus="stockinputfocus"
                  type="number"
                  class="stockinput"
                  pattern="[0-9]*"
                  v-model="stocktext"
                  placeholder="请输入股票代码"
                />
                <div class="stocklist" v-show="isshowstock">
                  <div
                    :class="['stitem', index % 2 == 0 ? 'b' : '']"
                    v-for="(items, index) in stocklist"
                    :key="index"
                    v-show="index < 5"
                    @mousedown="stocklistclick(items)"
                  >
                    <div class="c" v-html="resetstockcode(items.code)"></div>
                    <div class="n">{{ items.name }}</div>
                  </div>
                </div>
              </div>
              <div class="btn" @click="stockseachclick">搜索</div>
            </div>
            <div class="sx_2">
              <div class="tb_x1">
                <div class="name">
                  {{ stockdetail.length > 0 ? stockdetail[0] : "--" }}
                </div>
                <div class="prc">
                  {{ stockdetail.length > 0 ? stockdetail[1] : "--" }}
                </div>
              </div>
              <div class="tb_x2">
                <div class="code">
                  {{ stockdetail.length > 0 ? stockdetail[6] : "--" }}
                </div>
                <div class="time">
                  <span class="zd"
                    >{{ stockdetail.length > 0 ? stockdetail[13] : "--" }}
                    {{ stockdetail.length > 0 ? stockdetail[14] : "--" }}</span
                  >{{ stockcuttime }}
                </div>
              </div>
              <div class="tb_x3">
                <div class="">今开</div>
                <div class="">最高</div>
                <div class="">换手</div>
                <div class="">成交量</div>
              </div>
              <div class="tb_x4">
                <div class="">
                  {{ stockdetail.length > 0 ? stockdetail[7] : "--" }}
                </div>
                <div class="">
                  {{ stockdetail.length > 0 ? stockdetail[8] : "--" }}
                </div>
                <div class="">
                  {{ stockdetail.length > 0 ? stockdetail[12] : "--" }}
                </div>
                <div class="">
                  {{ stockdetail.length > 0 ? stockdetail[10] : "--" }}
                </div>
              </div>
              <div class="tb_x5">
                <div class="">昨收</div>
                <div class="">最低</div>
                <div class="">振幅</div>
                <div class="">成交额</div>
              </div>
              <div class="tb_x6">
                <div class="">
                  {{ stockdetail.length > 0 ? stockdetail[4] : "--" }}
                </div>
                <div class="">
                  {{ stockdetail.length > 0 ? stockdetail[9] : "--" }}
                </div>
                <div class="">
                  {{ stockdetail.length > 0 ? stockdetail[3] : "--" }}
                </div>
                <div class="">
                  {{ stockdetail.length > 0 ? stockdetail[11] : "--" }}
                </div>
              </div>
            </div>
            <div class="sx_3" @click.stop="stockpostevenclick(item)">
              领取<span class="n" v-show="stockdetail.length > 0">{{
                stockdetail.length > 0 ? stockdetail[0] : ""
              }}</span
              >测评结果
            </div>
          </div>
        </div>
        <div v-if="item.type === 'compass'" class="compass">
          <img :src="item.src" class="layimg" />
          <div class="zhzback">
            <img :src="img1" class="zhzimg" />
            <div class="zhzgroup">
              <img :src="img2" class="zhzgroupimg" />
              <div class="zhzcent">
                <img :src="img3" class="zhzcentimg" />
              </div>
            </div>
          </div>
        </div>
        <div v-if="item.type === 'qrcode'" class="qrcode">
          <img
            :src="item.src"
            class="back"
            @load="setqrsite($event, item)"
          /><img
            :src="item.qrsparecheck && isqrspare ? item.qrsparesrc : item.qrsrc"
            class="qr"
            :style="`left:${item.position.X}px;top:${item.position.Y}px;width:${item.position.W}px;`"
          />
        </div>
        <!-- 获客助手二维码显示 -->
        <div
          v-if="
            (item.hkzs_showType === 'qrcode' && hkzsQrcodeData) ||
            (item.addWxOption == 'ewQrGroup' &&
              ewqr_imgsrc != '' &&
              !isMicroPayent &&
              item.type == 'link')
          "
          class="hkzs-qrcode"
        >
          <div class="hkzs-qrcode-bg">
            <img
              :src="hkzsBackgroundOption.src"
              @load="onBackgroundImageLoad"
              class="bg-image"
            />
            <img
              v-if="item.addWxOption == 'ewQrGroup'"
              :src="ewqr_imgsrc"
              :style="hkzsQrcodeStyle"
              class="qr-code-positioned"
            />
            <vue-qr
              v-else
              :text="hkzsQrcodeData"
              :size="200"
              color-dark="#000000"
              color-light="#ffffff"
              :margin="0"
              :style="hkzsQrcodeStyle"
              class="qr-code-positioned"
            ></vue-qr>
          </div>
        </div>
        <div v-if="item.type === 'video'" class="video">
          <iframe
            title="player"
            class="iframevideo"
            v-if="
              typeof item.videovhallactivityId != 'undefined' &&
              item.videovhallactivityId != ''
            "
            allowfullscreen
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
            oallowfullscreen="true"
            msallowfullscreen="true"
            scrolling="no"
            frameborder="0"
            :src="`${apilist('videosrc')}${
              item.videovhallactivityId
            }?embed=video`"
          ></iframe>
        </div>
        <div v-if="item.type === 'application'" class="udtitle application">
          <div class="applicform">
            <div class="input">
              <input
                type="text"
                v-model="applictxt1"
                :placeholder="item.applicph1"
              />
            </div>
            <div class="input">
              <input
                type="text"
                v-model="applictxt2"
                :placeholder="item.applicph2"
              />
            </div>
            <div class="input">
              <div class="inputsub" @click="setapplic(item)">
                {{ item.applicbtntext }}
              </div>
            </div>
          </div>
        </div>
        <div v-if="item.type == 'popupwx' && ispopupwxshow" class="popupwx">
          <div class="popupboxlay">
            <div class="popupclose" @click.stop="closepopupwxbox"></div>
            <img class="popupboximg" :src="item.src" />
          </div>
        </div>
      </div>
    </div>
    <div class="stockshowbox" v-show="isshowstockbox">
      <div class="stockshowlay">
        <div class="t">{{ stockboxtxt }}</div>
        <div class="b">
          <mt-progress :value="stockboxvalue" :bar-height="20"></mt-progress>
        </div>
      </div>
    </div>
    <div :class="['popupbox', popupshow ? 'popupshow' : '']">
      <div class="popupboxlay">
        <div class="popupclose" @click="popupshow = false"></div>
        <div v-if="popupitem != ''">
          <img
            v-if="
              popupitem.type == 'application' && popupitem.applicbtntype == 1
            "
            :src="popuppicsrc"
          />
          <div
            v-else-if="popupitem.linkopt == 5 && popupitem.popuppictype == 1"
            class="popformlay"
          >
            <div class="item">
              <div class="item-l">您的姓名</div>
              <div class="item-r">
                <input
                  type="text"
                  placeholder="X先生/小姐"
                  v-model="popform1.name"
                />
              </div>
            </div>
            <div class="item">
              <div class="item-l">手机号码</div>
              <div class="item-r">
                <input
                  type="text"
                  placeholder="输入手机号码"
                  v-model="popform1.mobile"
                />
              </div>
            </div>
            <div class="item">
              <div class="item-l">盈亏状态</div>
              <div class="item-r">
                <select class="el-select" v-model="popform1.select1">
                  <option selected="selected">不清楚</option>
                  <option>亏损40%以上</option>
                  <option>收益20%-50%</option>
                  <option>亏损20%-40%</option>
                  <option>亏损20%以内</option>
                  <option>盈利20%以内</option>
                  <option>盈利20%-40%</option>
                  <option>盈利40%以上</option>
                </select>
              </div>
            </div>
            <div class="item">
              <div class="item-l">资金状况</div>
              <div class="item-r">
                <select class="el-select" v-model="popform1.select2">
                  <option selected="selected">不清楚</option>
                  <option>5万以下</option>
                  <option>5~10万</option>
                  <option>10~20万</option>
                  <option>20~50万</option>
                  <option>50~100万</option>
                  <option>100万以上</option>
                </select>
              </div>
            </div>
            <div class="item">
              <div class="item-l">操作风格</div>
              <div class="item-r">
                <select class="el-select" v-model="popform1.select3">
                  <option selected="selected">不清楚</option>
                  <option>超短线（T+0或T+1）</option>
                  <option>短中线（T+5~20）</option>
                  <option>中长线（T+20以上）</option>
                </select>
              </div>
            </div>
            <div class="item">
              <div class="item-l">选股思路</div>
              <div class="item-r">
                <select class="el-select" v-model="popform1.select4">
                  <option selected="selected">不清楚</option>
                  <option>技术分析型</option>
                  <option>估值模型型</option>
                  <option>可靠消息型</option>
                </select>
              </div>
            </div>
            <div class="contion">PS:本次个人投资者申请仅限内部核心用户！</div>
            <div class="formbtn" @click="popformpost1">提交</div>
          </div>
          <div
            v-else-if="popupitem.linkopt == 5 && popupitem.popuppictype == 2"
            class="popformlay zpopformlay"
          >
            <div class="item">
              <div class="item-l">机构名称</div>
              <div class="item-r">
                <input
                  type="text"
                  placeholder="XX基金管理有限公司"
                  v-model="popform2.text1"
                />
              </div>
            </div>
            <div class="item">
              <div class="item-l">法人代表</div>
              <div class="item-r">
                <input type="text" v-model="popform2.text2" />
              </div>
            </div>
            <div class="item">
              <div class="item-l">注册地址</div>
              <div class="item-r">
                <input type="text" v-model="popform2.text3" />
              </div>
            </div>
            <div class="item">
              <div class="item-l">董秘联系电话</div>
              <div class="item-r">
                <input type="text" v-model="popform2.text4" />
              </div>
            </div>
            <div class="item">
              <div class="item-l">管理资金规模</div>
              <div class="item-r">
                <input type="text" v-model="popform2.text5" />
              </div>
            </div>
            <div class="item">
              <div class="item-l">组织机构代码</div>
              <div class="item-r">
                <input type="text" v-model="popform2.text6" />
              </div>
            </div>
            <div class="contion">
              PS:机构投资者资金规模不得低于3000万，且近三年净值保持正增长
            </div>
            <div class="formbtn" @click="popformpost2">提交</div>
          </div>
          <img v-else @click="popupimgclick" :src="popuppicsrc" />
        </div>
        <img v-else @click="popupimgclick" :src="popuppicsrc" />
      </div>
    </div>
    <div class="addwechatdialog" v-if="isShowWechatDialog">
      <div class="awmain">
        <div class="close" @click="isShowWechatDialog = false"></div>
        <div class="avant">
          <img
            src="https://photo28.hexun.com/img/2024/0618/o_142a8a91237c42aeb08abc933d2ab5ac.png"
          />
        </div>
        <div class="t">和讯小助理</div>
        <div class="ds">北京和讯在线信息｜企业微信·客服</div>
        <div class="c">为了您的上课体验，请添加老师小助理哦</div>
        <div class="btn" @click="backbtnaddWechat">立即添加</div>
      </div>
    </div>
    <div
      :class="['h5LoginFreeBox', h5LoginFreeBox.item.userAgreementPopup]"
      v-if="h5LoginFreeBox.isH5LoginFreeBoxShow"
    >
      <div class="freelayout">
        <div class="img"></div>
        <div class="floatlay">
          <div class="term">
            <label>
              <input type="checkbox" v-model="h5LoginFreeBox.isAgree" />
            </label>
            <p class="term-p">
              <a
                href="https://jinchan-pay.hexun.com/help/personalHelp/service_rules.html"
                >钱包服务协议</a
              >、
              <a
                href="https://jinchan-pay.hexun.com/help/personalHelp/privacy_rules.html"
                >钱包隐私声明</a
              >、
              <a href="https://www.homeway.com.cn/xy/xz.html">用户须知</a>
            </p>
          </div>
          <div class="btn" @click="h5LoginFree"></div>
        </div>
      </div>
    </div>
    <div
      class="recovery_popup"
      v-if="showRecoveryPopup"
      @click.stop="closeRecoveryPopup"
    >
      <div class="recovery_popup_box" @click.stop="">
        <div class="recovery_popup_content">
          <div class="recovery_popup_title_wrap">
            <div class="recovery_popup_title_left_bg"></div>
            <div class="recovery_popup_title_shadow">
              {{ modeopt.recoveryPopupTitle }}
            </div>
            <div class="recovery_popup_title">
              {{ modeopt.recoveryPopupTitle }}
            </div>
            <div class="recovery_popup_title_right_bg"></div>
          </div>
          <div class="recovery_popup_value">
            <div v-html="processedText(modeopt.recoveryPopupValueText)"></div>
          </div>
          <div class="recovery_popup_fixed">
            {{ modeopt.recoveryPopupFixedText }}
          </div>
          <div
            class="recovery_popup_button"
            @click="handelRecoveryPopupClickBuy"
          >
            <div
              class="recovery_popup_button_text"
              v-html="processedText(modeopt.recoveryPopupButtonText)"
            ></div>
            <div class="tuijian">推荐</div>
          </div>
          <div class="recovery_popup_close" @click="closeRecoveryPopup">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <g clip-path="url(#clip0_39_39)">
                <path
                  d="M10 8.99998L14.5002 4.49965L15.5002 5.49969L11.0001 10L15.5002 14.5002L14.5002 15.5002L10 11.0001L5.49993 15.5004L4.49987 14.5004L9 10L4.49994 5.50007L5.49998 4.50002L10 8.99998Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_39_39">
                  <rect width="20" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast, Indicator, MessageBox } from "mint-ui";
import loginfordy from "@/components/loginfordy.vue";
import VueQr from "vue-qr";
import micropayment from "@/mixins/micropayment.js";
import MicropaymentCom from "@/components/micropaymentcom.vue";
export default {
  mixins: [micropayment],
  name: "App",
  components: {
    // 加载抖音sdk
    loginfordy: loginfordy,
    VueQr: VueQr,
    micropaymentCom: MicropaymentCom,
  },
  /**
   * @description: 本地存储
   * @param {*}
   * @return {*}
   */
  data() {
    return {
      // 所有配置加载完成
      isLoadedAll: false,
      // 活码组二维码地址
      ewqr_imgsrc: "",
      // H5登录免费支付弹窗
      h5LoginFreeBox: {
        isH5LoginFreeBoxShow: false,
        isAgree: true,
      },
      // 设备id用于abtest
      deviceId: "",
      // 实验id
      testId: "",
      //测试实验组1走和讯登录2走抖音sdk登录
      testgroupid: 1,
      // 是否弹窗广告引导弹窗
      ispopupwxshow: false,
      // 弹出挽留弹窗
      isShowWechatDialog: false,
      // 获客助手二维码内容
      hkzsQrcodeData: "",
      //抖音SDK
      isloaddysdk: false,
      //散户表单提交
      popform1: {
        name: "",
        mobile: "",
        select1: "不清楚",
        select2: "不清楚",
        select3: "不清楚",
        select4: "不清楚",
      },
      //机构表单提交
      popform2: {
        text1: "",
        text2: "",
        text3: "",
        text4: "",
        text5: "",
        text6: "",
      },
      //加企微二维码
      isqrspare: "",
      // 设备ID
      serviceId: "",
      // url参数exUserId
      exUserId: "",
      // url参数unionid
      unionid: "",
      //  报名表单提交信息1
      applictxt1: "",
      //  报名表单提交信息2
      applictxt2: "",
      // 机构弹窗
      popupshow: false,
      // 弹窗图片地址
      popuppicsrc: "",
      // 弹窗链接
      popuppiclink: "",
      // 弹窗表单对象
      popupitem: "",
      // 是否登陆
      islogin: false,
      // 用户信息
      userinfo: {},
      // 测试信息
      testscroll: {
        stockinput: 0,
        bodyheight: 0,
      },
      // 测评结果1
      img1: require("@/assets/images/znz.png"),
      // 测评结果2
      img2: require("@/assets/images/znzround.png"),
      // 测评结果3
      img3: require("@/assets/images/zzhen.png"),
      // 诊股
      isshowstockbox: false,
      // 诊股信息
      stockboxtxt: "",
      // 诊股指针
      stockboxvalue: 0,
      // 诊股股票涨跌
      isstockup: true,
      // 诊股时间
      stockcuttime: "--",
      // 诊股信息
      stocktext: "",
      // 诊股详情
      stockdetail: [],
      // 查询股票列表
      stocklist: [],
      // 显示股票弹窗
      isshowstock: false,
      // 手机号组件倒计时
      cdnum: 0,
      // 手机号验证码id
      captchaId: "d9121847d7414c29b91525902be9e5be",
      // 手机号验证码
      validate: "",
      // 图形验证码
      edunstate: 0,
      // 手机号码
      phonenumber: "",
      // 手机验证码
      phonecode: "",
      // 图形验证码
      phoneimgcode: "",
      // 图形验证码图片地址
      phoneimgcodesrc: "",
      // 确认复选框
      phonecheckbox: false,
      // 易盾
      ishasphonecont: false,
      // 小程序列表
      wxapplist: [],
      // 模式id
      id: 0,
      // 模式标题
      title: "",
      // 模式列表
      modelist: [],
      // 模式配置
      modeopt: [],
      // 小程序相关配置
      organizationId: "",
      // 短链地址
      sorturl: null,
      // 客服列表
      servicelist: [],
      // 获客助手二维码背景样式
      hkzsQrcodeStyle: {},
      hkzsBackgroundOption: {},
      // 是否展示订单查询状态
      showPaySuccess: true,
      isShowRecoveryPopup: false,
      recoveryPopupTimer: null,
      recoveryPopupTimeOver: false,
      recoveryPopupClickBuy: false,
      ishandelRecoveryPopup: false,
      recoveryTimer: null,
      recoveryTime: 0,
    };
  },
  watch: {
    /**
     * @description:监听股票代码
     * @return {*}
     */
    stocktext(a) {
      const _this = this;
      _this.getstock(a);
    },
    /**
     * @description:监听手机验证码
     * @return {*}
     */
    phonecode(a) {
      const _this = this;
      if (a.length >= 6) {
        _this.phonecode = a.substring(0, 6);
      }
    },
  },
  computed: {
    // 处理文本，将特殊文本用样式包裹
    processedText: () => {
      return (text) => {
        // 将文本分割成普通文本和特殊文本部分
        const parts = text?.split(/(\{[^}]+\})/g) || [];

        // 处理每个部分
        return parts
          .map((part) => {
            if (part.startsWith("{") && part.endsWith("}")) {
              // 处理特殊文本
              const content = part.slice(1, -1);
              return `<span class="supplementary_text_important">${content}</span>`;
            } else if (part.length > 0) {
              // 改为检查长度而非trim()，保留所有空格
              // 处理普通文本，添加white-space样式确保空格显示
              return `<span style="white-space: pre-wrap;">${part}</span>`;
            }
            return part; // 返回空字符串
          })
          .join("");
      };
    },
    // 显示用户挽留弹窗
    showRecoveryPopup() {
      const type =
        this.isShowRecoveryPopup &&
        this.recoveryPopupTimeOver &&
        !this.recoveryPopupClickBuy;

      if (type) {
        this.recoveryTimer = setInterval(() => {
          this.recoveryTime++;
        }, 1000);
        this._sendTrack("view_retention_popup", {
          campaign_id: this.markeyPage.combinationId,
          url: window.location.href,
          content_url: this.modelist[0].href,
          partner_id: this.markeyPage.partnerId,
          product_id: this.getStrParam("groupid", this.modelist[0].href),
        });
      }
      return type;
    },
  },
  // 创建完毕
  created() {
    const _this = this;
    // 用户挽留模式
    if (
      _this.getUrlParam("retention") == 1 &&
      sessionStorage.getItem("retention") == null
    ) {
      sessionStorage.setItem("retention", 1);
      MessageBox({
        title: "提示",
        message: "数据已更新请点击升级",
        showCancelButton: false,
      }).then(function () {
        location.href = `https://${
          _this.isTest() ? "test" : ""
        }caidao.homeway.com.cn/visualh5/retention.html?gourl=${encodeURIComponent(
          location.href.replace("retention=1", "retention=2"),
        )}`;
      });
    } else if (
      _this.getUrlParam("retention") == 2 &&
      sessionStorage.getItem("retention") == 1
    ) {
      sessionStorage.setItem("retention", 2);
    } else if (
      _this.getUrlParam("retention") == 1 &&
      sessionStorage.getItem("retention") == 2
    ) {
      sessionStorage.setItem("retention", 3);
      _this.isShowWechatDialog = true;
    }
    // 监听页面显示
    document.addEventListener(
      "visibilitychange",
      function () {
        if (document.visibilityState == "visible") {
          console.log("页面显示");
          if (
            _this.getUrlParam("retention") == 1 &&
            sessionStorage.getItem("retention") == 2
          ) {
            sessionStorage.setItem("retention", 3);
            _this.isShowWechatDialog = true;
          }
        }
      },
      false,
    );
    // 设备ID随机10位数
    _this.deviceId = _this.getdeviceId(10);
    // 保存获取到的unionid
    _this.unionid =
      _this.getUrlParam("unionId") == null ? "" : _this.getUrlParam("unionId");
    // 保存获取到的serviceId
    _this.serviceId =
      _this.getUrlParam("serviceId") == null
        ? ""
        : _this.getUrlParam("serviceId");
    // 保存获取到的exUserId
    _this.exUserId =
      _this.getUrlParam("exUserId") == null
        ? ""
        : _this.getUrlParam("exUserId");
    // 保存获取到的id
    _this.id =
      _this.getUrlParam("id") != null
        ? _this.getUrlParam("id")
        : location.pathname.split("/")[1].split(".html")[0];
    // 如果utm_campaign包含_zbupload则上报地址
    if (
      _this.getUrlParam("utm_campaign") != null &&
      _this.getUrlParam("utm_campaign").indexOf("_zbupload") > -1
    ) {
      _this.postutm();
    }
    // // 上报用户行为
    // _this.postuseraction();
    // 二维码组件如果有exUserId 说明不显示二维码显示新上传的图片
    if (_this.serviceId != "") {
      var csparams = {
        serviceId: _this.serviceId,
        exUserId: _this.exUserId,
      };
      $.ajax({
        url: _this.apilist("getServiceCustomerStatus"),
        type: "post",
        dataType: "json",
        xhrFields: {
          withCredentials: true,
        },
        //contentType: "application/json;charset=utf-8",
        // data: {
        //   reurl:location.href
        // },
        data: csparams,
      })
        .done(function (rs) {
          if (rs.data == 1) {
            // 二维码组件得用户加过企微
            _this.isqrspare = true;
          }
        })
        .fail(function () {
          console.log("error");
        })
        .always(function () {});
    }
    // 如果有授权则关联用户关系上报
    if (_this.unionid != "") {
      var uidparams = {
        unionid: _this.unionid,
        reurl: encodeURIComponent(location.href),
      };
      $.ajax({
        url: _this.apilist("uploadUserActionRecord"),
        type: "post",
        dataType: "json",
        xhrFields: {
          withCredentials: true,
        },
        data: uidparams,
      })
        .done(function (rs) {
          if (rs.data == 1) {
            console.log("unionid已授权，上报数据");
          }
        })
        .fail(function () {
          console.log("error");
        })
        .always(function () {});
    }
    // 不在抖音环境默认dplus
    // if (!_this.isdyversion()) {
    //   dplus_Click("页面浏览", {
    //     页面名称: "投放页面",
    //     事件名称: '页面浏览',
    //     PLATFORM: "h5",
    //   });
    // }
    // 获取roundkey
    _this.roundkey = _this.getUrlParam("roundkey");
    // 获取登录信息
    _this.httpToHttps.checklogin().then((_loginInfo) => {
      _this.islogin = _loginInfo.islogin ? true : false;
      if (_this.islogin) {
        // 上报到scrm
        _this.postuseraction();
      }
      _this.userinfo = _loginInfo;
      //   获取编辑器保存内容
      _this.getData(
        _this.apilist("getmarketpagebyid"),
        function (res) {
          if (res.resultKey === "ok") {
            if (JSON.stringify(res.data) == "{}") {
              // 20231017空数据跳转到404
              location.href = `https://${
                _this.isTest() ? "test" : ""
              }caidao.homeway.com.cn/err404/index.html`;
            }
            _this.title = res.data.pageName;
            if (res.data.pageName !== "") {
              document.title = res.data.pageName;
            }
            _this.markeyPage = res.data;
            _this.organizationId = res.data.organizationId;
            _this.setmode(res.data.pageContent);
          } else {
            MessageBox({
              title: "提示",
              message: "请确认url参数是否正确",
              showCancelButton: false,
            });
            _this.isLoadedAll = true;
          }
        },
        {
          id: _this.id,
        },
      );
    });
    // 加一个参数jump=1
    // 如果此页面需要判断“无需重复购买”，则该参数生效，自动做以下判断：
    // 1、判断是否已登录，未登录则跳登录页，已登录则继续
    if (_this.getUrlParam("jump") == 1) {
      _this.isjump = true;
      $("body").append("<style id ='appcss'>#app{display:none}</style>");
    }
  },
  methods: {
    /**
     * @description: 集成网页登录
     * @return {*}
     */
    h5login() {
      const _this = this;
      var params = {
        checkMobile: 0,
        checkJump: 1,
        gourl:
          location.href.indexOf("?") > -1
            ? `${this.formateRecoveryUrl(location.href)}&jump=1`
            : `${location.href}?jump=1`,
      };
      // 有callback=说明是快手登录，需要特殊加密
      // if(window.location.href.indexOf('callback=')>-1){
      //   params.gourl = `${window.location.href.split('?')[0]}?${encodeURIComponent(window.location.href.split('?')[1])}`
      // }
      if (_this.isMicroPayent) {
        // 小于1元的订单走特殊流程
        _this.$refs.micropaymentcom.popupLogin().then((_rs) => {
          if (_rs) {
            _this.evenclick(_this.modelist[0], false);
          }
        });
      } else {
        _this.httpToHttps && _this.httpToHttps.login(params);
      }
    },
    /**
     * @description: 获取小程序ID
     * @return {*}
     */
    getMiniappId(fn) {
      const _this = this;
      // 获取小程序id
      _this.getData(_this.apilist("getappid"), function (re) {
        if (re.code * 1 === 0) {
          //   加企微id
          window.wxappid = re.data.common;
          // 支付小程序id
          window.wxpayappid =
            _this.getUrlParam("wxappid") != null
              ? _this.getUrlParam("wxappid")
              : re.data.pay;
          window.wxartcilappid = re.data.article;
          fn && fn(re.data);
        }
      });
    },
    /**
     * @description: 登录时上报用户行为
     * @return {*}
     */
    postuseraction() {
      const _this = this;
      const params = {
        reurl: encodeURIComponent(location.href),
        eventType: "form",
      };
      $.ajax({
        url: _this.apilist("uploadPageUserAction"),
        type: "post",
        dataType: "json",
        xhrFields: {
          withCredentials: true,
        },
        //contentType: "application/json;charset=utf-8",
        // data: {
        //   reurl:location.href
        // },
        data: params,
      })
        .done(function (rs) {})
        .fail(function () {
          console.log("error");
        })
        .always(function () {});
    },
    /**
     * @description: 关闭引导弹窗
     * @return {*}
     */
    closepopupwxbox() {
      const _this = this;
      _this.ispopupwxshow = false;
      _this._sendTrack("clickPopupWindow", {
        page_name: "投放页面",
        redirect_url: "",
        button_name: "弹窗关闭",
        from_source: "h5",
      });
    },
    /**
     * @description: 添加企业微信
     * @return {*}
     */
    backbtnaddWechat() {
      const _this = this;
      setTimeout(function () {
        location.href = _this.addWechatUrl;
      }, 300);
    },
    /**
     * @description: 弹窗机构表单提交
     * @return {*}
     */
    popformpost2() {
      const _this = this;
      if (_this.popform2.text1 == "") {
        Toast("请输入机构名称");
        return;
      }
      if (_this.popform2.text2 == "") {
        Toast("请输入法人代表");
        return;
      }
      if (_this.popform2.text3 == "") {
        Toast("请输入注册地址");
        return;
      }
      if (_this.popform2.text4 == "") {
        Toast("请输入董秘联系电话");
        return;
      }
      if (_this.popform2.text5 == "") {
        Toast("请输入管理资金规范");
        return;
      }
      if (_this.popform2.text6 == "") {
        Toast("请输入组织机构代码");
        return;
      }
      if (_this.unionid == "") {
        _this.gowx();
        return;
      }
      const params = {
        name2: _this.popform2.text1,
        name: _this.popform2.text2,
        address: _this.popform2.text3,
        mobile: _this.popform2.text4,
        funds: _this.popform2.text5,
        code: _this.popform2.text6,
        unionid: _this.unionid,
        activityName: _this.title + "_国资盛宴",
        activityType: 3,
      };
      $.ajax({
        url: _this.apilist("weActivitySignUp"),
        type: "get",
        dataType: "json",
        xhrFields: {
          withCredentials: true,
        },
        data: params,
      })
        .done(function (rs) {
          if (rs.code == 200 || (rs.code == 500 && rs.msg == "1001")) {
            MessageBox({
              title: "提示",
              message: "提交成功",
              showCancelButton: false,
            }).then(function () {
              _this.popupshow = false;
            });
          } else {
            MessageBox({
              title: "提示",
              message: rs.msg,
              showCancelButton: false,
            });
          }
        })
        .fail(function () {
          console.log("error");
        })
        .always(function () {});
    },
    /**
     * @description: 弹窗散户表单提交
     * @return {*}
     */
    popformpost1() {
      const _this = this;
      if (_this.popform1.name == "") {
        Toast("请输入您的姓名");
        return;
      }
      if (_this.popform1.mobile == "") {
        Toast("请输入您的手机号");
        return;
      }
      if (_this.popform1.select1 == "不清楚") {
        Toast("请选择盈亏状态");
        return;
      }
      if (_this.popform1.select2 == "不清楚") {
        Toast("请选择资金状况");
        return;
      }
      if (_this.popform1.select3 == "不清楚") {
        Toast("请选择操作风格");
        return;
      }
      if (_this.popform1.select4 == "不清楚") {
        Toast("请选择选股思路");
        return;
      }
      if (_this.unionid == "") {
        _this.gowx();
        return;
      }
      const params = {
        name: _this.popform1.name,
        mobile: _this.popform1.mobile,
        income: _this.popform1.select1,
        funds: _this.popform1.select2,
        habits: _this.popform1.select3,
        thinking: _this.popform1.select4,
        unionid: _this.unionid,
        activityName: _this.title + "_国资盛宴",
        activityType: 2,
      };
      $.ajax({
        url: _this.apilist("weActivitySignUp"),
        type: "get",
        dataType: "json",
        xhrFields: {
          withCredentials: true,
        },
        data: params,
      })
        .done(function (rs) {
          if (rs.code == 200 || (rs.code == 500 && rs.msg == "1001")) {
            MessageBox({
              title: "提示",
              message: "提交成功",
              showCancelButton: false,
            }).then(function () {
              _this.popupshow = false;
            });
          } else {
            MessageBox({
              title: "提示",
              message: rs.msg,
              showCancelButton: false,
            });
          }
        })
        .fail(function () {
          console.log("error");
        })
        .always(function () {});
    },
    /**
     * @description: 去微信授权
     * @return {*}
     */
    gowx() {
      const _this = this;
      const url =
        _this.apilist("getwxunionid") + encodeURIComponent(location.href);
      location.href = url;
    },
    /**
     * @description: 检测登录授权
     * @return {*}
     */
    getwxautor() {
      const _this = this;
      if (_this.unionid == "") {
        if (_this.httpToHttps.isApp.isWx) {
          MessageBox({
            title: "提示",
            message: "本活动需要微信授权",
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonText: "允许",
          }).then(function (a) {
            if (a == "confirm") {
              _this.gowx();
            }
          });
        } else {
          MessageBox({
            title: "温馨提示",
            message: `请在微信中打开活动页面`,
            showCancelButton: false,
            showConfirmButton: true,
          }).then(function (a) {});
        }
      }
    },
    /**
     * @description: 报名提交信息
     * @return {*}
     */
    setapplic(item) {
      const _this = this;
      if (_this.applictxt1 == "" || _this.applictxt2 == "") {
        Toast("请输入完整信息！");
        return;
      }
      if (_this.unionid == "") {
        _this.gowx();
        return;
      }
      const params = {
        unionid: _this.unionid,
        name: _this.applictxt1,
        mobile: _this.applictxt2,
        activityName: "跨周金股",
        activityType: 1,
      };
      $.ajax({
        url: _this.apilist("weActivitySignUp"),
        type: "get",
        dataType: "json",
        xhrFields: {
          withCredentials: true,
        },
        data: params,
      })
        .done(function (rs) {
          if (rs.code == 200 || (rs.code == 500 && rs.msg == "1001")) {
            // 弹窗提示
            if (item.applicbtntype == 1) {
              // _this.popuppiclink = '';
              // _this.popuppicsrc = item.popuppicsrc;
              // _this.popupshow = true;
              _this.popupbox(item);
            }
            // 页面跳转
            if (item.applicbtntype == 2) {
              location.href = item.href;
            }
          } else {
            MessageBox({
              title: "提示",
              message: rs.msg,
              showCancelButton: false,
            });
          }
        })
        .fail(function () {
          console.log("error");
        })
        .always(function () {});
    },
    /**
     * @description: 上报utm参数
     * @return {*}
     */
    postutm() {
      const _this = this;
      const params = {
        reurl: location.href,
      };
      $.ajax({
        url: _this.apilist("uploadZbUserAction"),
        type: "post",
        dataType: "json",
        xhrFields: {
          withCredentials: true,
        },
        //contentType: "application/json;charset=utf-8",
        // data: {
        //   reurl:location.href
        // },
        data: params,
      })
        .done(function (rs) {})
        .fail(function () {
          console.log("error");
        })
        .always(function () {});
      // $.ajax({
      //   type: "post",
      //   url: _this.apilist("uploadZbUserAction"),
      //   data: params,
      //   dataType: "json",
      //   xhrFields: {
      //     withCredentials: true
      //   },
      //   success(rs) {
      //     if (rs.code == 1) {

      //     }
      //   },
      // });
      // $.post(_this.apilist("uploadZbUserAction"), params,
      //   function(data){
      //       console.log(data)
      //   }
      // );
    },
    /**
     * @description:
     * @return {*}
     */
    setqrsite(e, item) {
      const _this = this;
      // 配置高度
      let yh =
        414 / ($(e.target)[0].naturalWidth / $(e.target)[0].naturalHeight);
      let position = {
        X: (item.position.X / 414) * $(e.target).width(),
        Y: (item.position.Y / yh) * $(e.target).height(),
        W: (item.position.W / 414) * $(e.target).width(),
        H: 0,
      };
      if (item.position.X == "auto") {
        position.X =
          ($(window).width() -
            ((item.position.W / 414) * $(e.target).width() + 12)) /
          2;
      }
      const arr = [];
      let _list = _this.modelist;
      for (var i in _list) {
        if (item.id == _list[i].id) {
          _list[i].position = position;
        }
        arr.push(_list[i]);
      }
      _this.modelist = arr;
    },
    /**
     * @description: popupimgclick
     * @return {*}
     */
    popupimgclick() {
      const _this = this;
      if (
        _this.popuppiclink != "" &&
        typeof _this.popuppiclink != "undefined"
      ) {
        location.href = _this.popuppiclink;
      }
    },
    /**
     * @description: 弹窗处理
     * @param {*} item
     * @return {*}
     */
    popupbox(item) {
      const _this = this;
      _this.popuppiclink = item.popuppiclink;
      _this.popuppicsrc = item.popuppicsrc;
      console.log(item);
      _this.popupitem = item;
      _this.popupshow = true;
    },
    /**
     * @description: 生成invoketoken
     * @return {*}
     */
    webtokens(item) {
      const _this = this;
      let random = `${new Date().getTime()}${parseInt(Math.random() * 10000)}`;
      return {
        param: `mode_${item.id}id_${_this.id}token_${random}`,
        token: random,
      };
    },
    /**
     * @description: 处理当前url参数传递到returnurl
     * @return {*}
     */
    handleUrlParams(returnurl) {
      const _this = this;
      let arr = _this.urltourlparam(location.search);
      let narr = {};
      for (let key in arr) {
        if (
          key != "mark" &&
          key != "mark1" &&
          key != "utm_campaign" &&
          key != "utm_source" &&
          key != "jump" &&
          key != "advertiserId"
        ) {
          narr[key] = arr[key];
        }
      }
      let paramtourl = _this.paramtourl(narr);
      paramtourl =
        paramtourl && paramtourl != "" && paramtourl != null
          ? `&${paramtourl}`
          : "";
      let urlpar = `${decodeURIComponent(returnurl)}&caidaoadid=${
        _this.id
      }${paramtourl}`;
      // 保存当前url参数到localStorage,用于跳客服时传递参数
      localStorage.setItem(
        "urlparams",
        `caidaoadid=${_this.id}&${_this.paramtourl(narr)}`,
      );
      return _this.removeDuplicateKeys(urlpar);
    },
    /**
     * @description: 快捷支付点击
     * @return {*}
     */
    fastpayclick(item) {
      const _this = this;
      // 如果支付类型为H5退款或小程序登录下单
      if (
        item.payMentType &&
        (item.payMentType == "h5RefundWithoutLogin" ||
          item.payMentType == "miniappLoginOrder")
      ) {
        if (item.payMentType == "h5RefundWithoutLogin") {
          _this.clickH5LoginFree(item);
          //_this.h5LoginFree(item);
        }
        return;
      }
      // 如果已登录
      if (_this.islogin) {
        // 如果是单品
        if (item.fastpayprotype == 2) {
          // 获取单品信息
          _this.getData(
            _this.apilist("getproductinfo"),
            function (res) {
              if (res.respCode == "0") {
                // 如果是0元直接下单
                item.isfree = res.result.price * 1 == 0 ? true : false;
                if (item.noRepeatPurchase) {
                  // 获取N天前的日期
                  _this.getData(
                    _this.apilist("getuserordercount"),
                    function (res) {
                      if (res.respCode == "0") {
                        // 如果已购买过，则跳转到客服
                        if (res.result.buytimes * 1 > 0) {
                          _this.buyToCustom(item);
                        } else {
                          _this.fastpay(item);
                        }
                      } else {
                        if (
                          typeof res == "object" &&
                          res.toString().indexOf("Timeout") > -1
                        ) {
                          console.log("getuserordercount接口超时");
                        }
                        _this.fastpay(item);
                      }
                    },
                    {
                      productid: item.wxpayproductid,
                      orderStatus: 1,
                      onlyCheckOrderIsExist: 1,
                      gteFinishtimeUtx: _this.getGteFinishtimeUtxParam(),
                    },
                    3000,
                  );
                } else {
                  _this.fastpay(item);
                }
              } else {
                if (
                  typeof res == "object" &&
                  res.toString().indexOf("Timeout") > -1
                ) {
                  console.log("getproductinfo接口超时");
                }
                _this.fastpay(item);
              }
            },
            {
              productid: item.wxpayproductid,
              priceid: item.wxpaypriceid,
            },
            3000,
          );
        } else {
          _this.isHasBeenPaid({
            groupid: item.wxpaygroupid,
            isVerification: item.noRepeatPurchase,
            callback(res) {
              // 返回两个集合getpackageinfo:{},getuserordercount:{}
              if (res.getpackageinfo.respCode == "0") {
                item.isfree =
                  res.getpackageinfo.result.price * 1 == 0 ? true : false;
                // 需要验证是否购买过,或者是小于1元支付
                if (item.noRepeatPurchase) {
                  if (res.getuserordercount.respCode == "0") {
                    // 如果已购买过，则跳转到客服
                    if (res.getuserordercount.result.buytimes * 1 > 0) {
                      _this.buyToCustom(item);
                    } else {
                      _this.fastpay(item);
                    }
                  } else {
                    if (
                      typeof res == "object" &&
                      res.getuserordercount.toString().indexOf("Timeout") > -1
                    ) {
                      console.log("getuserordercount接口超时");
                    }
                    _this.fastpay(item);
                  }
                } else {
                  _this.fastpay(item);
                }
              } else {
                if (
                  typeof res == "object" &&
                  res.toString().indexOf("Timeout") > -1
                ) {
                  console.log("getpackageinfo接口超时");
                }
                _this.fastpay(item);
              }
            },
          });
          // 套餐需要获取套餐中全部id
          // _this.getData(
          //   _this.apilist("getpackageinfo"),
          //   function (res) {
          //     if (res.respCode == "0") {
          //       // 如果是0元直接下单
          //       item.isfree = res.result.price * 1 == 0 ? true : false;
          //       let arrparams = [];
          //       arrparams.push(item.wxpaygroupid);
          //       if (
          //         res.result.bindPackageVOList &&
          //         res.result.bindPackageVOList.length > 0
          //       ) {
          //         for (let i in res.result.bindPackageVOList) {
          //           arrparams.push(res.result.bindPackageVOList[i].groupID);
          //         }
          //       }
          //       // 判断是否需要验证下过单
          //       if (item.noRepeatPurchase) {
          //         _this.getData(
          //           _this.apilist("getuserordercount"),
          //           function (res) {
          //             if (res.respCode == "0") {
          //               // 如果已购买过，则跳转到客服
          //               if (res.result.buytimes * 1 > 0) {
          //                 _this.buyToCustom(item);
          //               } else {
          //                 _this.fastpay(item);
          //               }
          //             } else {
          //               if (
          //                 typeof res == "object" &&
          //                 res.toString().indexOf("Timeout") > -1
          //               ) {
          //                 console.log("getuserordercount接口超时");
          //               }
          //               _this.fastpay(item);
          //             }
          //           },
          //           {
          //             productid: arrparams.toString(),
          //             orderStatus: 1,
          //             onlyCheckOrderIsExist: 1,
          //             gteFinishtimeUtx,
          //           },
          //           3000
          //         );
          //       } else {
          //         _this.fastpay(item);
          //       }
          //     } else {
          //       if (
          //         typeof res == "object" &&
          //         res.toString().indexOf("Timeout") > -1
          //       ) {
          //         console.log("getpackageinfo接口超时");
          //       }
          //       _this.fastpay(item);
          //     }
          //   },
          //   {
          //     groupid: item.wxpaygroupid,
          //     getBindGroupInfo: 1,
          //   },
          //   3000
          // );
        }
      } else {
        // 未登录
        // 上报到scrm
        _this.postuseraction();
        // 如果需要弹出抖音登录
        if (_this.isloaddysdk && item.dyAutoLogin) {
          _this._evenclicksendTrack(
            {
              test_id: _this.testId,
              test_group_id: "2",
              deviceId: _this.deviceId,
            },
            item,
          );
          _this.$refs.dysdk.init(item);
        } else {
          // 如果不需要弹出抖音登录,走H5登录
          _this._evenclicksendTrack(
            {
              test_id: _this.testId,
              test_group_id: "1",
              deviceId: _this.deviceId,
            },
            item,
          );
          _this.h5login();
        }
      }
    },
    /**
     * @description: 快捷支付
     * @return {*}
     */
    fastpay(item) {
      const _this = this;
      function _pay() {
        if (_this.islogin) {
          let fastpaybackurl =
            item.fastpaybackurl && item.fastpaybackurl != ""
              ? _this.resetutmcampaign(item.fastpaybackurl, "pay")
              : location.href;
          let invoketoken = _this.webtokens(item);
          //保存抖音参数 ,将参数传入returnurl
          if (location.href.indexOf("?") > -1 && item.fastpaybackurl != "") {
            fastpaybackurl = _this.handleUrlParams(fastpaybackurl);
          }
          let params = {
            number: 1,
            paytype: "wxpay",
            returnurl: _this.replaceUrlParams(
              fastpaybackurl,
              "invoketoken",
              invoketoken.token,
            ),
            invoketoken: invoketoken.token,
          };
          _this.modelist[0]._invoketoken = invoketoken.token;
          // 快捷支付是否跳转到中间页
          if (item.fastisjump) {
            params.returnurl = `https://${
              _this.isTest() ? "test" : ""
            }caidao.homeway.com.cn/visualh5/payment.html?invoketoken=${
              invoketoken.param
            }`;
            params.invoketoken = invoketoken.token;
          }
          if (item.fastpayprotype == 1) {
            params.groupid = item.wxpaygroupid;
          }
          if (item.fastpayprotype == 2) {
            params.priceid = item.wxpaypriceid;
            params.productid = item.wxpayproductid;
          }
          // 如果有mark1，将其值传入参数coopuserflag
          if (location.href.indexOf("mark1") > -1) {
            params.coopuserflag = _this.getUrlParam("mark1");
          }
          // 如果有utm_campaign，将其值传入参数utmCampaign
          if (location.href.indexOf("utm_campaign") > -1) {
            let utmCampaign = _this.getUrlParam("utm_campaign");

            params.utmCampaign = _this.formateRecoveryUrl("", utmCampaign);
          }
          // 如果是0元的免费
          if (item.isfree) {
            let par = {
              isPackage: item.fastpayprotype == 1 ? 1 : 0,
              isOpenRight: 1,
              number: 1,
              productId:
                item.fastpayprotype == 1
                  ? item.wxpaygroupid
                  : item.wxpayproductid,
              priceId: item.fastpayprotype == 1 ? "" : item.wxpaypriceid,
            };
            _this.getData(
              _this.apilist("freeorderopenright"),
              function (res) {
                if (res.respCode == "0") {
                  Indicator.open("下单成功！正在为您跳转...");
                  setTimeout(function () {
                    Indicator.close();
                    console.log("快捷支付的0元套餐");
                    location.href = params.returnurl;
                  }, 2000);
                  _this._evenclicksendTrack({ url: params.returnurl }, item);
                } else {
                  MessageBox({
                    title: "提示",
                    message: res.errorMgs,
                    showCancelButton: false,
                  });
                  // location.href = `${_this.apilist("fastpay")}?${_this.paramtourl(
                  //   params
                  // )}`;
                }
              },
              par,
            );
          } else {
            const url = `${_this.apilist("fastpay")}?${_this.paramtourl(
              params,
            )}`;
            console.log(url);
            setTimeout(() => {
              console.log("快捷支付-非0套餐", url);
              location.href = url;
            }, 300);
            _this._evenclicksendTrack({ url }, item);
          }
        } else {
          _this.postuseraction();
          _this.h5login();
        }
      }
      // 小于1元支付需要弹窗
      if (_this.isMicroPayent) {
        _this.$refs.micropaymentcom.popupProConfirm({
          callback(submit) {
            if (submit) {
              _pay();
            }
          },
        });
      } else {
        _pay();
      }
    },
    /**
     * @description:
     * @return {*}
     */
    mainscroll() {
      const _this = this;
      return;
      _this.testscroll.stockinput = $(".stockinput").offset().top;
      _this.testscroll.bodyheight = document.body.clientHeight / 2;
    },
    /**
     * @description:获得焦点
     * @return {*}
     */
    stockinputfocus() {
      //const _this = this;
      if ($(".stockinput").offset().top > document.body.clientHeight / 2) {
        console.log("股票输入框处于屏幕中上未知");
        //$('.main').css('overflow','hidden')
        //$('.main').animate({'scrollTop':`${($('.stockinput').offset().top + $('.main').scrollTop() - document.body.clientHeight/4 - 40)}px`})
      } else {
        //$('.main').scrollTop($('.stockinput').offset().top+$('.main').scrollTop()/2)
      }
    },
    /**
     * @description:失去焦点
     * @return {*}
     */
    stockinputblur() {
      //const _this = this;
      if ($(".stockinput").offset().top > document.body.clientHeight / 2) {
        $(".main").scrollTop(
          $(".stockinput").offset().top +
            $(".main").scrollTop() -
            document.body.clientHeight / 4 -
            40,
        );
        //$('.main').scrollTop($('.stockinput').offset().top + $('.main').scrollTop() - document.body.clientHeight/4);
        //$('.main').animate({'scrollTop':`${($('.stockinput').offset().top + $('.main').scrollTop() - document.body.clientHeight/4 - 40)}px`})
        // let atimer = setInterval(function(){
        //     $('.main').scrollTop($('.stockinput').offset().top + $('.main').scrollTop() - document.body.clientHeight/4 - 40)
        // },10)
        // setTimeout(function(){
        //     $('.main').css('overflow','')
        //     clearInterval(atimer)
        // },1000)
        //$('.main').css('overflow','')
      } else {
        //$('.main').scrollTop($('.stockinput').offset().top+$('.main').scrollTop()/2)
      }
    },
    /**
     * @description:诊股动画
     * @return {*}
     */
    stockanimata(fn) {
      const _this = this;
      _this.isshowstockbox = true;
      _this.stockboxtxt = "正在通过事件驱动策略模型";
      _this.stockboxvalue = 0;
      clearInterval(window.stockanimat);
      window.stockanimat = setInterval(function () {
        _this.stockboxvalue++;
        if (_this.stockboxvalue > 25 && _this.stockboxvalue < 50) {
          _this.stockboxtxt = "正在通过OLT算法确定必要报酬率";
        }
        if (_this.stockboxvalue > 50 && _this.stockboxvalue < 75) {
          _this.stockboxtxt = "正在通过VAR系统确认风险值";
        }
        if (_this.stockboxvalue > 75) {
          _this.stockboxtxt = "正在通过量价交易模型";
        }
        if (_this.stockboxvalue > 99) {
          clearInterval(window.stockanimat);
          _this.isshowstockbox = false;
          fn && fn();
        }
      }, 30);
    },
    /**
     * @description:点击诊股
     * @return {*}
     */
    stockpostevenclick(item) {
      const _this = this;
      // 获取微信unionid
      if (_this.unionid == "" && item.isstockwxauth) {
        _this.gowx();
        return;
      }
      if (_this.stockdetail.length > 0) {
        _this.stockanimata(function () {
          if (item.isstockwxauth) {
            const params = {
              unionid: _this.unionid,
              activityName: _this.title + "_诊股",
              activityType: 4,
              remark: `${_this.stockdetail[0]}${_this.stockdetail[6]
                .replace(/\(/gi, "")
                .replace(/\)/gi, "")}`,
            };
            $.ajax({
              url: _this.apilist("weActivitySignUp"),
              type: "get",
              dataType: "json",
              xhrFields: {
                withCredentials: true,
              },
              data: params,
            })
              .done(function (rs) {
                if (rs.code == 200 || (rs.code == 500 && rs.msg == "1001")) {
                  _this.evenclick(item, true);
                } else {
                  MessageBox({
                    title: "提示",
                    message: rs.msg,
                    showCancelButton: false,
                  });
                }
              })
              .fail(function () {
                console.log("error");
              })
              .always(function () {});
          } else {
            _this.evenclick(item, true);
          }
        });
      } else {
        Toast("请输入正确的股票信息");
      }
    },
    /**
     * @description:股票时间
     * @return {*}
     */
    stocknowtime() {
      const _this = this;
      clearInterval(window.stocktimer);
      window.stocktimer = setInterval(function () {
        const dateMat = new Date();
        const year = dateMat.getFullYear();
        const month = dateMat.getMonth() + 1;
        const day = dateMat.getDate();
        const hh =
          dateMat.getHours() > 9
            ? dateMat.getHours()
            : "0" + dateMat.getHours();
        const mm =
          dateMat.getMinutes() > 9
            ? dateMat.getMinutes()
            : "0" + dateMat.getMinutes();
        const ss =
          dateMat.getSeconds() > 9
            ? dateMat.getSeconds()
            : "0" + dateMat.getSeconds();
        const timeFormat =
          year + "/" + month + "/" + day + " " + hh + ":" + mm + ":" + ss;
        _this.stockcuttime = timeFormat;
      }, 1000);
    },
    /**
     * @description:查询股票代码
     * @return {*}
     */
    stockseachclick() {
      const _this = this;
      if (_this.stocktext == "") {
        Toast("请输入股票代码");
        return;
      }
      let stocktype = "SZSE";
      if (_this.stocklist.length > 0) {
        _this.stocklist.map(function (item, index) {
          if (item.code == _this.stocktext) {
            stocktype = item.orgcode;
          }
        });
      }
      const params = {
        code: stocktype + _this.stocktext,
        column:
          "name,price,priceweight,vibrationratio,lastclose,excode,code,open,high,low,volume,amount,exchangeratio",
        ver: 1,
      };
      _this.getData(
        _this.apilist("getstockdetai"),
        function (rs) {
          _this.resultstock(rs.Data);
          _this.isshowstock = false;
        },
        params,
      );
    },
    /**
     * @description:股票代码结果
     * @return {*}
     */
    resultstock(a) {
      const _this = this;
      if (a && a != null && a != "" && a.length > 0) {
        let stockdetail = JSON.parse(JSON.stringify(a[0][0]));
        let result = a[0][0];
        result[4] = result[4] * 1 > 0 ? result[4] : 1;
        console.log(result);
        // 计算当前价
        stockdetail[1] = parseFloat(result[1] / result[2]).toFixed(2);
        // 股票代码
        stockdetail[6] = `(${result[6]})`;
        // 涨幅
        stockdetail.push(
          parseFloat((result[1] - result[4]) / result[2]).toFixed(2),
        );
        // 涨跌幅
        stockdetail.push(
          parseFloat(((result[1] - result[4]) / result[4]) * 100).toFixed(2) +
            "%",
        );
        // 今开
        stockdetail[7] = parseFloat(result[7] / result[2]).toFixed(2);
        // 最高
        stockdetail[8] = parseFloat(result[8] / result[2]).toFixed(2);
        // 换手
        stockdetail[12] = parseFloat(result[12] / 100).toFixed(2) + "%";
        // 成交量
        stockdetail[10] = parseFloat(result[10] / 1000000).toFixed(2) + "万";
        // 昨收
        stockdetail[4] = parseFloat(result[4] / result[2]).toFixed(2);
        // 最低
        stockdetail[9] = parseFloat(result[9] / result[2]).toFixed(2);
        // 振幅
        stockdetail[3] = parseFloat(result[3] / 100).toFixed(2);
        // 成交额
        stockdetail[11] = parseFloat(result[11] / 100000000).toFixed(2) + "亿";
        if (result[1] < result[4]) {
          _this.isstockup = false;
        } else {
          _this.isstockup = true;
        }
        _this.stockdetail = stockdetail;
      } else {
        Toast("没有相关的股票信息");
        _this.stockdetail = [];
      }
    },
    /**
     * @description:
     * @return {*}
     */
    stockinputkeyup() {
      const _this = this;
      if (_this.stocklist.length > 0) {
        _this.isshowstock = true;
      }
    },
    /**
     * @description:
     * @return {*}
     */
    stocklistclick(item) {
      const _this = this;
      _this.isshowstock = false;
      _this.stocktext = item.code;
    },
    /**
     * @description:
     * @return {*}
     */
    resetstockcode(a) {
      let text = "";
      if (a) {
        text = a.replace(
          this.stocktext,
          `<span class="r">${this.stocktext}</span>`,
        );
      }
      return text;
    },
    /**
     * @description:
     * @return {*}
     */
    getstock(a) {
      const _this = this;
      const params = {
        key: a,
      };
      $.ajax({
        type: "get",
        url: _this.apilist("getstock"),
        data: params,
        dataType: "jsonp",
        xhrFields: {
          withCredentials: true,
        },
        success: function (rs) {
          //_this.evenclick(item, true);
          console.log(rs);
        },
        complete: function (rs) {
          _this.stocklist = hxSuggest_JsonData;
          //   检测如果是股票代码自动搜索
          if (a.length > 5) {
            hxSuggest_JsonData.map(function (item, index) {
              if (item.code == _this.stocktext) {
                _this.stockseachclick();
              }
            });
          }
        },
      });
    },
    /**
     * @description:
     * @return {*}
     */
    autotolink(item) {
      const _this = this;
      console.log("🚀🚀", _this.islogin);
      if (
        _this.isloadautoservertolink ||
        (_this.isMicroPayent &&
          _this.markeyPage.combinationType == "customerService")
      ) {
        return;
      }
      let isneedjump = _this.isjump ? true : item.autolink;
      if (item.linktype == 3 && item.linkopt == 1) {
        // 判断是否拉起小程序客服，需要获取小程序id
        if (item.addWxOption == "miniapp") {
          _this.getMiniappId((_data) => {
            // 获取小程序id
            if (_data.h5v2 && _data.h5v2.length > 0) {
              _data.h5v2.forEach((element) => {
                if (element.configId == item.miniappConfigId) {
                  window.wxappid = element.appid;
                  _this.getminiprosorturl(() => {
                    // 如果需要自动拉起跳转
                    if (isneedjump) {
                      _this.evenclick(item, true);
                    }
                  });
                }
              });
            }
          });
        } else {
          if (isneedjump) {
            _this.evenclick(item, true);
          }
        }
      } else {
        if (isneedjump) {
          _this.evenclick(item, true);
        }
      }
      _this.isloadautoservertolink = true;
    },
    /**
     * @description: 处理安卓键盘无法顶起输入框的问题
     * @return {*}
     */
    scollandroidsit(e) {
      const ua = navigator.userAgent.toLowerCase();
      let isadroid =
        ua.indexOf("android") > -1 || ua.indexOf("linux") > -1 ? true : false;
      let iswx = ua.indexOf("micromessenger") > -1 ? true : false;
      if (isadroid && !iswx) {
        const top = $(e.target).parents(".item").offset().top;
        if (top > $(window).height() / 3) {
          $(".main").scrollTop(top);
        }
      }
    },
    /**
     * @description: 将url参数转成json
     * @return {*}
     */
    formaturltojson(url) {
      const search = url.split("?")[1];
      if (!search) {
        return {};
      }
      return JSON.parse(
        '{"' +
          decodeURIComponent(search)
            .replace(/"/g, '\\"')
            .replace(/&/g, '","')
            .replace(/=/g, '":"')
            .replace(/\+/g, " ") +
          '"}',
      );
    },
    /**
     * @description: 绑定scrm
     * @return {*}
     */
    bindscrm(item) {
      const _this = this;
      const ajaxurl = item.phoselectfunurl;
      //item.logincode
      //item.userid
      const dmain = ajaxurl.indexOf("?") > -1 ? ajaxurl.split("?")[0] : ajaxurl;
      const params = _this.formaturltojson(ajaxurl);
      params.mobile = _this.phonenumber;
      params.hexunId = item.userid;
      params.hexunName = item.username;
      $.ajax({
        type: "get",
        url: dmain,
        data: params,
        dataType: "json",
        xhrFields: {
          withCredentials: true,
        },
        success: function (rs) {
          //_this.evenclick(item, true);
          console.log(rs);
        },
        complete: function (rs) {
          _this.evenclick(item, true);
        },
      });
      // const npar =JSON.stringify(params).replace(/"/g,'').replace(/,/g,'&').replace(/:/g,'=')
      // console.log(npar)
    },
    /**
     * @description: 手机号组件点击
     * @return {*}
     */
    getphonesubclick(item) {
      const _this = this;
      if (!_this.phonenumber * 1 > 0) {
        MessageBox({
          title: "提示",
          message: "请输入手机号码",
          showCancelButton: false,
        });
        return;
      }
      if (!_this.phonecode * 1 > 0) {
        MessageBox({
          title: "提示",
          message: "请输入手机验证码",
          showCancelButton: false,
        });
        return;
      }
      if (!_this.phonecheckbox && !item.phocheckagreement) {
        MessageBox({
          title: "提示",
          message: "请阅读协议",
          showCancelButton: false,
        });
        return;
      }
      const params = {
        Acs_Appid: "7518681818",
        Acs_Interfaceid: "2007847970",
        mobile: _this.phonenumber,
        flag: "advertising",
        code: _this.phonecode,
      };
      //   $.post(_this.apilist("phonelogin"),params,function(data,status){
      //     alert("Data: " + data + "nStatus: " + status);
      // },'json');
      $.ajax({
        type: "post",
        url: _this.apilist("phonelogin"),
        data: params,
        dataType: "json",
        success(rs) {
          if (rs.code == 1) {
            item.logincode = rs.data.code;
            item.userid = rs.data.user.UserId;
            item.username = rs.data.user.UserName;
            if (
              typeof item.phoselectfunurl != "undefined" &&
              item.phoselectfunurl != ""
            ) {
              _this.bindscrm(item);
            } else {
              _this.evenclick(item, true);
            }
          } else {
            MessageBox({
              title: "提示",
              message: rs.msg,
              showCancelButton: false,
            });
          }
        },
      });
    },
    /**
     * @description: 发送验证码后倒计时
     * @return {*}
     */
    countdown() {
      const _this = this;
      _this.cdnum = 60;
      window.cdnumtimer = setInterval(() => {
        _this.cdnum = _this.cdnum - 1;
        if (_this.cdnum == 0) {
          window.clearInterval(window.cdnumtimer);
        }
      }, 1000);
    },
    /**
     * @description: 获取图形验证码
     * @return {*}
     */
    getimgcode() {
      const _this = this;
      _this.phoneimgcodesrc = `${_this.apilist(
        "imgcode",
      )}?Acs_Appid=7518681818&Acs_Interfaceid=2002096318&date=${new Date().getTime()}`;
    },
    /**
     * @description: 获取手机号验证码
     * @return {*}
     */
    getphonecode() {
      const _this = this;
      if (_this.cdnum > 0) {
        return;
      }
      if (!_this.phonenumber * 1 > 0) {
        MessageBox({
          title: "提示",
          message: "请输入手机号码",
          showCancelButton: false,
        });
        return;
      }
      if (_this.phoneimgcode == "" && _this.edunstate == 2) {
        MessageBox({
          title: "提示",
          message: "请输入图形验证码",
          showCancelButton: false,
        });
        return;
      }
      // 如果开启易盾
      if (_this.edunstate == 1) {
        window.captchaIns && window.captchaIns.verify();
      }
      // 易盾关闭走图形验证码
      else {
        _this.sendphocode();
      }
    },
    /**
     * @description: 发送手机验证码
     * @return {*}
     */
    sendphocode() {
      const _this = this;
      if (_this.cdnum != 0) {
        return;
      }
      const params = {
        Acs_Appid: "7518681818",
        Acs_Interfaceid: "2002802025",
        mobile: _this.phonenumber,
        use: 1,
        imagecode: _this.phoneimgcode,
        eDunValidate: _this.validate,
      };
      $.ajax({
        type: "get",
        url: _this.apilist("sendcode"),
        data: params,
        dataType: "json",
        xhrFields: {
          withCredentials: true,
        },
        success(rs) {
          if (rs.code == 1) {
            _this.countdown();
          } else {
            MessageBox({
              title: "提示",
              message: rs.msg,
              showCancelButton: false,
            });
          }
          // 发送成功后刷新易盾
          if (_this.edunstate == 1) {
            window.captchaIns && window.captchaIns.refresh();
          }
        },
      });
    },
    /**
     * @description: 配置易盾点击事件
     * @return {*}
     */
    initNECaptcha() {
      const _this = this;
      initNECaptcha(
        {
          element: "#captcha",
          captchaId: _this.captchaId,
          width: "320px",
          mode: "bind",
          onVerify: function (err, data) {
            /**
             * 第一个参数是err（Error的实例），验证失败才有err对象
             * 第二个参数是data对象，验证成功后的相关信息，data数据结构为key-value，如下：
             * {
             *   validate: 'xxxxx' // 二次验证信息
             * }
             **/
            if (err) return; // 当验证失败时，内部会自动refresh方法，无需手动再调用一次

            // 点击登录按钮后可调用服务端接口，以下为伪代码，仅作示例用
            _this.validate = data.validate;
            _this.sendphocode();
          },
        },
        function onload(instance) {
          window.captchaIns = instance;
        },
        function onerror(err) {
          console.warn(err);
        },
      );
    },
    /**
     * @description: 获取易盾状态
     * @return {*}
     */
    getedunstate() {
      const _this = this;
      const params = {
        Acs_Appid: "7518681818",
        Acs_Interfaceid: "2001603636",
      };
      $.ajax({
        type: "get",
        url: _this.apilist("edunstate"),
        data: params,
        dataType: "json",
        success(rs) {
          if (rs.code == 1) {
            if (rs.data == 1) {
              _this.edunstate = 1;
              _this.initNECaptcha();
            } else if (rs.data == 0) {
              _this.edunstate = 2;
              _this.getimgcode();
            }
          }
        },
      });
    },
    /**
     * @description: 判断抖音版本
     * @return {*}
     */
    isdyversion() {
      try {
        //2024-04-21低版本无法执行抖音快捷登录
        //版本验证
        const APP_VERSION_REGX = {
          android: /app_version\//i,
          ios: /aweme_/i,
        };
        const ua = navigator.userAgent;
        const os = /(Android);?\s+([\d.]+)?/i.test(ua) ? "android" : "ios";
        const version = parseFloat(
          ua.split(APP_VERSION_REGX[os])[1].replace("lite_", ""),
        );
        if (version) {
          if (version >= parseFloat("10.8.0")) {
            return true;
          }
        }
      } catch {}
      return false;
    },
    /**
     * @description: 获取模版队列
     * @param {*} id 机构id
     * @return {*}
     */
    getadmodelist() {
      const _this = this;
      //const par = [];
      let isneedwxauth = false;
      // let isneeddyauth = false;
      // let isneedMiniappId = false;
      // let isneedMiniConfigId = null
      let isneedautolink = false;
      let autolinkitem = _this.modelist[0];
      let groupId = "";
      console.log(_this.modelist);
      for (let item of _this.modelist) {
        //par.push(item.wxmodebackid);
        // 是否需要客服自动跳转
        if (item.linktype == 3 && item.linkopt == 1) {
          isneedautolink = true;
          autolinkitem = item;
        }
        if (item.groupId && item.groupId * 1 > 0) {
          groupId = item.groupId;
        }
        // 如果有广告引导弹窗
        if (item.type === "popupwx" && _this.modeopt.popupToWx) {
          if (item.popupToWxShowTime && item.popupToWxShowTime * 1 > 0) {
            setTimeout(function () {
              _this.ispopupwxshow = true;
              _this._sendTrack("exposurePopupWindow", {
                page_name: "投放页面弹窗",
                from_source: "h5",
                button_name: "投放页弹窗",
              });
            }, item.popupToWxShowTime * 1000);
          } else {
            _this.ispopupwxshow = true;
          }
        }
        // 是否包含手机号组件
        if (item.type === "phone") {
          _this.ishasphonecont = true;
          // 如果有手机号组件，获取易盾状态
          _this.getedunstate();
        }
        // 如果有诊股组件
        if (item.type === "stock") {
          _this.stocknowtime();
          if (item.isstockwxauth) {
            isneedwxauth = true;
          }
        }
        // 如果需要获取unionid
        if (
          _this.unionid == "" &&
          (item.type === "application" ||
            (item.linkopt == 5 &&
              item.popuppictype &&
              item.popuppictype * 1 > 0))
        ) {
          isneedwxauth = true;
        }
        // 如果未加载sdk,支持抖音版本，允许拉起抖音授权，未登陆，是执行购买操作，则加载抖音sdk
        if (
          !_this.issdkloading &&
          !_this.isloaddysdk &&
          _this.isdyversion() &&
          item.dyAutoLogin &&
          !_this.islogin &&
          (item.linkopt == 4 ||
            (item.linkopt == 1 &&
              item.linktype == 2 &&
              item.href.indexOf("buy.homeway.com.cn") > -1))
        ) {
          _this.issdkloading = true;
          _this.isneeddyauth = true;
          // 获取deviceId
          // if(_this.testgroupid==2){
          //   _this.isloaddysdk=true;
          //   _this.issdkloading=false
          // }
        }
      }
      if (isneedwxauth) {
        _this.getwxautor();
      }
      // const params = {
      //   ids: par.toString(),
      // };
      // 需要获取抖音授权
      if (_this.isneeddyauth) {
        _this.isloaddysdk = true;
        _this.issdkloading = false;
        _this.testgroupid = 2;
      }
      // 需要自动跳转
      if (isneedautolink || _this.isjump) {
        Indicator.close();
        if (_this.isLoadedAll) {
          _this.autotolink(autolinkitem);
        } else {
          setTimeout(function () {
            _this.autotolink(autolinkitem);
          }, 1000);
        }
        //_this.autotolink(autolinkitem);
      }
      // 上报埋点
      _this._sendTrack("viewAllocateResources", {
        page_title: "营销课落地页",
        page_name: "投放页面",
        from_source: "h5",
        redirect_url: location.href,
        shuffle: _this.deviceId,
        package_id: "",
        retention_strategy: _this.modeopt.recoveryPopupStrategyEnabled
          ? "strategy_1"
          : "null",
        product_id: groupId,
        partner_id: _this.markeyPage.partnerId,
        url: location.href,
        campaign_id: _this.id,
      });
      if (_this.httpToHttps.env.isDy && _this.islogin) {
        // 上报埋点
        _this._sendTrack("click_douyin_auth", {
          auth_result: "手机号授权",
          page_title: "营销课落地页",
          page_name: "投放页面",
          from_source: "h5",
          redirect_url: location.href,
          product_id: groupId,
          partner_id: _this.markeyPage.partnerId,
          campaign_id: _this.id,
          action_result: "Success",
          url: location.href,
        });
      }
    },
    /**
     * @description: 根据id获取数据
     * @param {*} id
     * @return {*}
     */
    getmodelistbyid(id) {
      const _this = this;
      if (_this.wxapplist.length > 0) {
        const arr = _this.wxapplist;
        let item = "";
        for (let items of arr) {
          if (id == items.id) {
            item = items;
          }
        }
        return item;
      } else {
        return "";
      }
    },
    /**
     * @description: 去掉指定参数
     * @param url
     * @param parameter
     * @return {*}
     */
    removeURLParameter(url, parameter) {
      var urlparts = url.split("?");
      if (urlparts.length >= 2) {
        //参数名前缀
        var prefix = encodeURIComponent(parameter) + "=";
        var pars = urlparts[1].split(/[&;]/g);

        //循环查找匹配参数
        for (var i = pars.length; i-- > 0; ) {
          if (pars[i].lastIndexOf(prefix, 0) !== -1) {
            //存在则删除
            pars.splice(i, 1);
          }
        }

        return urlparts[0] + (pars.length > 0 ? "?" + pars.join("&") : "");
      }
      return url;
    },
    /**
     * @description: 获取小程序schema
     * @param {*} item
     * @return {*}
     */
    geturltowxapp(item) {
      const _this = this;
      const ispaymode =
        typeof item.wxmodetype != "undefined" && item.wxmodetype == 2
          ? true
          : false;
      const isarticlmode =
        typeof item.wxmodetype != "undefined" && item.wxmodetype == 3
          ? true
          : false;
      //   小程序模版id
      let modeid = item.wxmodebackid;
      //   userid&code
      let user = "";
      if (ispaymode) {
        // 小程序支付模版id
        modeid = item.wxpaymodebackid;
      }
      if (isarticlmode) {
        modeid = item.wxarticlbackid;
      }
      let modebackurl = item.wxmodebackurl;
      if (ispaymode) {
        modebackurl = item.wxpaymodebackurl;
      }
      if (isarticlmode) {
        modebackurl = encodeURIComponent(item.wxarticlbackurl);
      }
      const modetype =
        typeof item.wxmodetype != "undefined"
          ? `&wxmodetype=${item.wxmodetype}`
          : `&wxmodetype=1`;
      const back =
        typeof modeid != "undefined" && modeid * 1 > 0
          ? `&back=${modeid}&backurl=${modebackurl}`
          : "&back=0";
      let imghposition = "",
        mpo = false,
        nitem = "";
      if (!ispaymode && !isarticlmode) {
        nitem = _this.getmodelistbyid(item.wxmodebackid * 1);
        mpo = nitem === "" ? item.wxmodeposition : nitem.position;
      }
      if (mpo) {
        if (mpo.X && mpo.X != "auto") {
          imghposition += `&imgx=${mpo.X}`;
        }
        if (mpo.Y && mpo.Y != "auto") {
          imghposition += `&imgy=${mpo.Y}`;
        }
        if (mpo.W && mpo.W != "auto") {
          imghposition += `&imgw=${mpo.W}`;
        }
        if (mpo.H && mpo.H != "auto") {
          imghposition += `&imgh=${mpo.H}`;
        }
      }
      let istest = _this.isTest() ? "&istest=true" : "&istest=false";
      let version = _this.isTest() ? "trial" : "release";
      let wxtitle = `&wxtitle=${encodeURIComponent(document.title)}`;
      let reurl = encodeURIComponent(
        _this.removeURLParameter(location.href, "_toutiao_params"),
      );
      let path = "pages/index/index";
      if (ispaymode) {
        path = "pages/pay/index";
      }
      if (isarticlmode) {
        path = "pages/article/index";
      }
      let geturl = _this.apilist("getschema");
      if (ispaymode) {
        geturl = _this.apilist("getpayschema");
      }
      if (isarticlmode) {
        geturl = _this.apilist("getartcilschema");
      }
      //   userid&code
      if (item.userid * 1 > 0) {
        user = `&userid=${item.userid}&code=${item.logincode}`;
      }
      const params = {
        query: `utm_source=${
          _this.getUrlParam("utm_source") == null
            ? _this.markeyPage.launchChannel
            : _this.getUrlParam("utm_source")
        }&utm_campaign=${
          _this.getUrlParam("utm_campaign") == null
            ? _this.modeopt.launchChannel +
              "_" +
              _this.modeopt.pageUse +
              "_" +
              _this.modeopt.activityTimeLevel
            : _this.getUrlParam("utm_campaign")
        }${wxtitle}&linkid=${item.id}&pageid=${_this.id}&channel=${
          _this.markeyPage.organizationId
        }&roundkey=${
          _this.roundkey || item.roundkey
        }${back}${imghposition}${istest}${modetype}${user}&reurl=${reurl}`,
        version, //要打开的小程序版本。正式版为"release"，体验版为"trial"，开发版为"develop"，仅在微信外打开时生效。体验版和开发版仅在iOS上支持，Android将在近期支持。
        path,
      };
      $.ajax({
        type: "get",
        url: geturl,
        data: params,
        success: function (res) {
          if (res.code * 1 === 0) {
            location.href = res.data;
          } else {
            MessageBox({
              title: "提示",
              message: res.msg,
              showCancelButton: false,
            });
          }
        },
        complete: function () {
          Indicator.close();
        },
      });
    },
    /**
     * @description: 获取策略ID，userid > cookieSid > redomid
     * @param {*} length 随机数位数
     * @return {*}
     */
    getdeviceId(length) {
      const _this = this;
      let result = "";
      const len = length && length * 1 > 0 ? length : 10;
      let characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (let i = 0; i < len; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * characters.length),
        );
      }
      // 获取cookie中的设备id
      let cookieSid = _this.getCookie("HexunTrack");
      // 如果cookie中有设备id
      if (cookieSid && cookieSid.indexOf("=") > -1) {
        cookieSid = cookieSid.split("=")[1].split("&")[0];
        result = cookieSid;
      }
      // 如果登陆了有userid
      if (
        _this.userinfo &&
        _this.userinfo.userid &&
        _this.userinfo.userid * 1 > 0
      ) {
        result = _this.userinfo.userid;
      }
      return result;
    },
    /**
     * @description: 判断跳转连接如果是订单地址需要做前置登录，防止scrm上报丢失
     * @return {*}
     */
    ispayurl(url) {
      const _this = this;
      // 如果是1元一下支付，走特殊流程
      if (_this.isMicroPayent) {
        _this.$refs.micropaymentcom.init(url);
      } else {
        // 是订单页需要做前置登录
        if (
          !_this.islogin &&
          url.indexOf("buy.homeway.com.cn") > -1 &&
          (url.indexOf("product") > -1 || url.indexOf("package") > -1)
        ) {
          // 上报scrm
          _this.postuseraction();
          _this.h5login();
          return;
        }
        setTimeout(function () {
          console.log("recovery_ispayurl", url);
          // return;
          location.href = _this.resetutmcampaign(url, "pay");
        }, 300);
      }
    },
    /**
     * @description: 点击事件曝光
     * @return {*}
     */
    _evenclicksendTrack(params, item) {
      let _this = this;
      let sensors = "";
      if (
        _this.isShowRecoveryPopup &&
        _this.recoveryPopupTimeOver &&
        (!_this.recoveryPopupClickBuy || _this.ishandelRecoveryPopup)
      ) {
        // 点击的是弹窗
        sensors = "2";
      } else if (_this.modeopt.recoveryPopupStrategyEnabled) {
        sensors = `1`;
      } else {
        // 未开启弹窗并且弹窗也没弹出
        sensors = `0`;
      }
      let _params = {
        page_name: "投放页面",
        redirect_url: params.url || item.href,
        button_name: "点击投放页",
        shuffle: _this.deviceId,
        sensors: sensors,
      };
      _params = { ..._params, ...params };
      if (item.wxpaygroupid && item.wxpaygroupid * 1 > 0) {
        _params.package_id = item.wxpaygroupid;
      }
      if (_this.getStrParam("groupid", item.href) != null) {
        _params.package_id = _this.getStrParam("groupid", item.href);
      }
      _this._sendTrack("clickAllocateResources", _params);
      if (item.type == "popupwx") {
        _this._sendTrack("clickPopupWindow", {
          page_name: "投放页面",
          redirect_url: params.url || item.href,
          button_name: "弹窗打开",
          from_source: "h5",
        });
      }
    },
    /**
     * @description: 购买后跳转客服地址
     * @param {*} item
     * @return {*}
     */
    buyToCustom(item) {
      const _this = this;
      // 跳转至客服
      if (
        item.customerServiceUrl &&
        item.customerServiceUrl != "" &&
        item.customerServiceUrl != "javascript:void(0)"
      ) {
        //保存抖音参数 ,将参数传入returnurl
        if (location.href.indexOf("?") > -1) {
          let arr = _this.urltourlparam(location.search);
          let narr = {};
          for (let key in arr) {
            if (
              key != "mark" &&
              key != "mark1" &&
              key != "utm_campaign" &&
              key != "utm_source" &&
              key != "jump"
            ) {
              narr[key] = arr[key];
            }
          }
          // let urlpar = `${decodeURIComponent(params.returnurl)}&caidaoadid=${_this.id}&${_this.paramtourl(narr)}`
          // params.returnurl = (urlpar);
          // 已经购买过，则将参数保存到本地
          localStorage.setItem(
            "urlparams",
            `caidaoadid=${_this.id}&${_this.paramtourl(narr)}`,
          );
        }
        const url = this.formateRecoveryUrl(item.customerServiceUrl);
        // 如果有客服地址跳转客服地址url
        setTimeout(function () {
          console.log("recovery_buytoCustom", item);

          location.href = url;
        }, 300);
      } else {
        // 没有客服地址，本地拉起客服
        _this.customerservice(item);
      }
    },
    // 重构Recoveryurl
    formateRecoveryUrl(url, utmCampaign) {
      let recoveryType = "";

      if (
        this.isShowRecoveryPopup &&
        this.recoveryPopupTimeOver &&
        (!this.recoveryPopupClickBuy || this.ishandelRecoveryPopup)
      ) {
        // 点击的是弹窗
        recoveryType = `2`;
      } else if (this.modeopt.recoveryPopupStrategyEnabled) {
        recoveryType = `1`;
      } else {
        // 未开启弹窗并且弹窗也没弹出
        recoveryType = `0`;
      }
      let u = null,
        utm;
      if (url) {
        u = new URL(url);
        utm = u.searchParams.get("utm_campaign");
      } else {
        utm = utmCampaign;
      }
      if (utm) {
        const parts = utm.split("_");

        // 至少需要三段才会涉及平台 + 版本号结构
        if (parts.length >= 3) {
          const versionNumber = parts[parts.length - 1]; // 0 / 1 / ...

          // versionLetter 必须是一个字母
          if (/^[a-zA-Z]$/.test(versionNumber)) {
            console.log("formateRecovery", utm);

            parts.push(recoveryType);
            utm = parts.join("_");
          }
        } else {
          return url;
        }
      }
      if (url) {
        u.searchParams.set("utm_campaign", utm);

        return u.toString();
      } else {
        return utm;
      }
    },
    /**
     * @description: 处理url去重
     * @param {*} url
     * @return {*} 返回去重后的url
     */
    removeDuplicateParams(url) {
      if (!url) return url;
      // 分割url和参数
      const [baseUrl, queryString] = url.split("?");
      if (!queryString) return url;

      // 将参数字符串转换为数组，保持原始顺序
      const paramsArray = queryString.split("&");

      // 使用Map来存储参数，保留最后一个出现的值
      const paramsMap = new Map();
      paramsArray.forEach((param) => {
        const [key, value] = param.split("=");
        paramsMap.set(key, value);
      });

      // 将Map转回参数字符串
      const newQueryString = Array.from(paramsMap.entries())
        .map(([key, value]) => `${key}=${value}`)
        .join("&");

      // 返回处理后的完整url
      return `${baseUrl}?${newQueryString}`;
    },
    /**
     * @description: 获取href短连接传给小程序
     * @param {*} fn
     * @return {*}
     */
    getminiprosorturl(fn) {
      const _this = this;
      var localurl = location.href;
      // 获取本地保存的参数
      if (localStorage.getItem("urlparams") != null) {
        localurl =
          localurl.indexOf("?") > -1
            ? `${localurl}&${localStorage.getItem("urlparams")}`
            : `${localurl}?${localStorage.getItem("urlparams")}`;
      }
      if (_this.islogin) {
        const params = {
          Acs_Appid: "7518681818",
          Acs_Interfaceid: "2008396160",
        };
        _this.getData(
          _this.apilist("getuserid"),
          function (res) {
            if (res.code == 1) {
              localurl = _this.removeDuplicateParams(
                `${localurl}${
                  location.href.indexOf("?") > -1 ? "&" : "?"
                }userid=${res.data.userId}&code=${res.data.code}`,
              );
              //获取短连接
              $.ajax({
                url: _this.apilist("sorturl"),
                type: "get",
                dataType: "json",
                xhrFields: {
                  withCredentials: true,
                },
                data: { url: encodeURI(localurl) },
              })
                .done(function (rs) {
                  if (rs.code * 1 === 1) {
                    _this.sorturl = rs.data;
                    fn && fn();
                  } else {
                    MessageBox(rs.msg);
                  }
                })
                .fail(function () {})
                .always(function () {});
            }
          },
          params,
        );
      } else {
        localurl = _this.removeDuplicateParams(localurl);
        //   获取短连接
        $.ajax({
          url: _this.apilist("sorturl"),
          type: "get",
          dataType: "json",
          xhrFields: {
            withCredentials: true,
          },
          data: { url: encodeURI(localurl) },
        })
          .done(function (rs) {
            if (rs.code * 1 === 1) {
              _this.sorturl = rs.data;
              fn && fn();
            } else {
              MessageBox(rs.msg);
            }
          })
          .fail(function () {})
          .always(function () {});
      }
    },
    /**
     * @description: 跳转到小程序
     * @return {*}
     */
    linktominiprogram(item) {
      const _this = this;
      _this.getMiniProgramUrlLink(item);
    },
    /**
     * @description: 获取小程序链接
     * @return {*}
     */
    getMiniProgramUrlLink(item) {
      const _this = this;
      // const params = {
      //   query: `utm_source=${_this.getUrlParam('utm_source') == null ? _this.markeyPage.launchChannel : _this.getUrlParam('utm_source')}&utm_campaign=${_this.getUrlParam('utm_campaign') == null ? (_this.modeopt.launchChannel + '_' + _this.modeopt.pageUse + '_' + _this.modeopt.activityTimeLevel) : _this.getUrlParam('utm_campaign')}${wxtitle}&linkid=${item.id
      //     }&pageid=${_this.id}&channel=${_this.markeyPage.organizationId}&roundkey=${_this.roundkey || item.roundkey
      //     }${back}${imghposition}${istest}${modetype}${user}&reurl=${reurl}`,
      //   version, //要打开的小程序版本。正式版为"release"，体验版为"trial"，开发版为"develop"，仅在微信外打开时生效。体验版和开发版仅在iOS上支持，Android将在近期支持。
      //   path,
      // };
      $.ajax({
        type: "get",
        url: _this.apilist("getminiurllink"),
        data: {
          version: _this.isTest() ? "trial" : "release",
        },
        success: function (res) {
          if (res.code * 1 === 0) {
            let cq = `id=${_this.id}&sortreurl=${_this.sorturl}&ability=addwx&qrodesrc=${item.wxmodebackurl}`;
            // 获取分组ID
            if (item.miniappGroupId && item.miniappGroupId * 1 > 0) {
              cq = `${cq}&miniappgroupid=${item.miniappGroupId}`;
            }
            // 获取模板ID
            if (item.miniappModeId && item.miniappModeId * 1 > 0) {
              cq = `${cq}&miniappmodeid=${item.miniappModeId}`;
            }
            let urllink = `${res.data}?cq=${encodeURIComponent(cq)}`;
            console.log("urllink", urllink);
            location.href = urllink;
          } else {
            MessageBox({
              title: "提示",
              message: `获取小程序链接失败，${res.msg}`,
              showCancelButton: false,
            });
          }
        },
        complete: function () {
          Indicator.close();
          localStorage.removeItem("urlparams");
        },
      });
    },
    /**
     * @description: 获取浏览器唯一id
     * @return {*}
     */
    getBrowserId() {
      const _this = this;
      var browserId = localStorage.getItem("uniqueBrowserId");
      if (browserId != null && browserId != "") {
        return browserId;
      } else {
        browserId = _this.getCookie("hx_bigdata_uid").slice(-10);
        localStorage.setItem("uniqueBrowserId", browserId);
        return browserId;
      }
    },
    /**
     * @description: 获取token
     * @param {*} invoketoken
     * @return {*}
     */
    resetInvoketoken() {
      const _this = this;
      let bigdata = _this.getBrowserId();
      let id = _this.id;
      return `${bigdata}_${id.slice(-9)}`;
    },
    /**
     * @description: H5登录免费支付
     * @return {*}
     */
    h5LoginFree() {
      const _this = this;
      // 未选中协议，则不执行
      if (!_this.h5LoginFreeBox.isAgree) {
        Toast({
          message: "请先阅读并同意协议",
          duration: 2000,
        });
        return;
      }
      const item = _this.h5LoginFreeBox.item;
      // 获取支付成功后返回的url
      let fastpaybackurl =
        item.fastpaybackurl && item.fastpaybackurl != ""
          ? _this.resetutmcampaign(item.fastpaybackurl, "pay")
          : location.href;
      // 因为invoketoken最多支持20个字符,这里需要处理hx_bigdata_uid
      var invoketoken = _this.resetInvoketoken();
      // 获取支付参数
      let params = {
        number: parseFloat(item.payNum * 100).toFixed(0),
        //paytype: "alipay",
        returnurl: fastpaybackurl,
        onlySubmitPayBehavior: 1,
        invoketoken,
      };
      //保存本地url参数 ,将参数传入returnurl
      if (location.href.indexOf("?") > -1) {
        params.returnurl = _this.handleUrlParams(params.returnurl);
      }
      // 如果有mark1，将其值传入参数coopuserflag
      if (location.href.indexOf("mark1") > -1) {
        params.coopuserflag = _this.getUrlParam("mark1");
      }
      // 如果有utm_campaign，将其值传入参数utmCampaign
      if (location.href.indexOf("utm_campaign") > -1) {
        let utmCampaign = _this.getUrlParam("utm_campaign");
        // 开启了弹窗

        params.utmCampaign = _this.formateRecoveryUrl("", utmCampaign);
      }
      const url = `${_this.apilist("fastpay")}?${_this.paramtourl(params)}`;
      console.log(url);
      // 将购买日期存入本地
      localStorage.setItem(
        invoketoken,
        JSON.stringify({ invoketoken, invoketokenTime: new Date().getTime() }),
      );
      //alert(`点击去支付${invoketoken}`)
      // 执行购买
      setTimeout(() => {
        location.href = url;
      }, 300);
    },
    // 更新url参数
    updateUrlParam(url, paramName, extraText) {
      const u = new URL(url);

      // 1. 获取原参数
      const oldValue = u.searchParams.get(paramName);

      if (oldValue === null) {
        // 参数不存在
        return url;
      }

      // 2. 给参数值加上额外字符
      const newValue = oldValue + extraText;

      // 3. 重新设置回 URL
      u.searchParams.set(paramName, newValue);

      return u.toString();
    },
    /**
     * @description: 点击H5登录免费支付
     * @return {*}
     */
    clickH5LoginFree(item) {
      const _this = this;
      const invoketoken = _this.resetInvoketoken();
      const localStorageInvoketoken = localStorage.getItem(invoketoken);
      //alert(`点击页面开始判断${invoketoken}是否支付，本地token存储值${localStorage.getItem('uniqueBrowserId')}`)
      // 如果本地存有invoketoken，或者invoketoken为空，则获取cookie中的invoketoken
      if (
        localStorageInvoketoken &&
        localStorageInvoketoken != null &&
        localStorageInvoketoken != ""
      ) {
        //const invoketoken = JSON.parse(localStorageInvoketoken).invoketoken;
        const invoketokenTime = JSON.parse(
          localStorageInvoketoken,
        ).invoketokenTime;
        Indicator.open();
        // 通过接口获取是否购买过此产品
        _this.getData(
          _this.apilist("getInvoketokenOrderPayed"),
          function (res) {
            Indicator.close();
            if (res && res.respCode == 0) {
              // 0：未扫码，1：支付中，<订单号>：支付完成
              if (res.result && res.result.payResult * 1 > 1) {
                //  如果invoketokenTime与当前时间相差2天
                if (
                  new Date().getTime() - invoketokenTime <
                  2 * 24 * 60 * 60 * 1000
                ) {
                  // 如果相差2天内则无需购买直接跳转客服
                  console.log("如果相差2天内则无需购买直接跳转客服");
                  _this.buyToCustom(item);
                } else {
                  // 如果相差2天外，则需要重新购买
                  _this.h5LoginFreeBox.isH5LoginFreeBoxShow = true;
                  _this.h5LoginFreeBox.item = item;
                }
                // 修正本地数据
                if (
                  res.result.payedDatetime &&
                  res.result.payedDatetime != "" &&
                  res.result.payedDatetime.indexOf(":") > -1
                ) {
                  localStorage.setItem(
                    invoketoken,
                    JSON.stringify({
                      invoketoken,
                      invoketokenTime: new Date(
                        res.result.payedDatetime.replace(/-/g, "/"),
                      ).getTime(),
                    }),
                  );
                }
                //alert(`获取接口判断${invoketoken}已经支付`)
              } else {
                // 配置弹窗
                _this.h5LoginFreeBox.isH5LoginFreeBoxShow = true;
                _this.h5LoginFreeBox.item = item;
                //alert(`获取接口判断${invoketoken}未支付`)
              }
            } else {
              if (
                typeof res == "object" &&
                res.toString().indexOf("Timeout") > -1
              ) {
                // 接口超时继续弹出购买
                _this.h5LoginFreeBox.isH5LoginFreeBoxShow = true;
                _this.h5LoginFreeBox.item = item;
              } else {
                MessageBox({
                  title: "提示",
                  message: res.respMgs,
                  showCancelButton: false,
                });
              }
            }
          },
          { invoketoken, needQueryOrderInfo: 1 },
          3000,
        );
      } else {
        // 本地没有保存invoketoken，说明没有购买过,配置弹窗去执行购买
        _this.h5LoginFreeBox.isH5LoginFreeBoxShow = true;
        _this.h5LoginFreeBox.item = item;
        //alert(`未查询到本地存储的${invoketoken}支付信息`)
      }
    },
    /**
     * @description: 根据次级别类型判断是否需要执行点击事件
     * @param {*} item
     * @return {*}
     */
    evenclickforlinkType(item) {
      const _this = this;
      //   如果是小程序
      if (item.linktype == 1) {
        Indicator.open();
        if (_this.roundkey === null) {
          if (typeof item.roundkey != "undefined" && item.roundkey * 1 > 0) {
            _this.roundkey = item.roundkey;
          }
        }
        if (item.wxmodetype == 1 && _this.roundkey == null) {
          MessageBox({
            title: "提示",
            message: "请确认url中roundkey参数是否正确",
            showCancelButton: false,
          });
        } else {
          _this.geturltowxapp(item);
        }
      }
      //   如果是链接
      if (item.linktype == 2) {
        //  判断未登录并且需要自动执行第一模块
        if (!_this.islogin && _this.isjump) {
          // 上报到scrm
          _this.postuseraction();
          _this.h5login();
          return;
        }
        if (item.href !== "" && item.href != "javascript:void(0)") {
          //  保存当前url参数
          if (location.href.indexOf("?") > -1) {
            let arr = _this.urltourlparam(location.search);
            let narr = {};
            for (let key in arr) {
              if (
                key != "mark" &&
                key != "mark1" &&
                key != "utm_campaign" &&
                key != "utm_source" &&
                key != "jump"
              ) {
                narr[key] = arr[key];
              }
            }
            localStorage.setItem(
              "urlparams",
              `caidaoadid=${_this.id}&${_this.paramtourl(narr)}`,
            );
          }
          //   如果 noRepeatPurchaseDays 为0则一直可以购买。如果大于0则需要判断是否购买过
          if (
            _this.getStrParam("groupid", item.href) != null &&
            item.noRepeatPurchaseDays &&
            item.noRepeatPurchaseDays * 1 > 0 &&
            _this.islogin
          ) {
            // 验证订单是否买过，买过则直接跳转到 customerServiceUrl
            _this.verifyorder(_this.getStrParam("groupid", item.href), item);
          } else {
            // 如果需要弹出抖音登录
            if (_this.isloaddysdk && item.dyAutoLogin && !_this.islogin) {
              // 上报到scrm
              _this.postuseraction();
              _this._evenclicksendTrack(
                {
                  test_id: _this.testId,
                  test_group_id: "2",
                  deviceId: _this.deviceId,
                },
                item,
              );
              _this.$refs.dysdk.init(item);
            } else {
              _this.ispayurl(item.href);
              _this._evenclicksendTrack(
                {
                  url: item.href,
                  test_id: _this.testId,
                  test_group_id: "1",
                  deviceId: _this.deviceId,
                },
                item,
              );
            }
          }
        }
      }
      //   跳转客服
      if (item.linktype == 3) {
        _this.customerservice(item);
      }
    },
    /**
     * @description: 重要事件，根据类型处理，包含点击事件和非点击
     * @param {*}item
     * @param {*}can 非点击事件
     * @return {*}
     */
    evenclick(item, can) {
      const _this = this;
      // 未配置完成禁止点击
      if (!_this.isLoadedAll) {
        return;
      }
      console.log(item);
      this.recoveryPopupClickBuy = true;
      if ((item.type === "phone" || item.type === "stock") && !can) {
        return;
      }
      if (item.href && item.href !== "" && item.href != "javascript:void(0)") {
        // 处理item.href中的utm_campaign
        item.href = _this.resetutmcampaign(item.href);
      }
      if (
        item.customerServiceUrl &&
        item.customerServiceUrl !== "" &&
        item.customerServiceUrl != "javascript:void(0)"
      ) {
        // 处理item.customerServiceUrl
        item.customerServiceUrl = _this.resetutmcampaign(
          item.customerServiceUrl,
        );
      }
      // 祖级权重判断
      if (item.linkopt == 1) {
        //祖级别权重为1则进入次级判断
        _this.evenclickforlinkType(item);
      } else if (item.linkopt == 2) {
        //   是置顶滚动到顶部
        if (item.linkopt == 2) {
          $(".main").animate(
            {
              scrollTop: 0,
            },
            300,
          );
        }
      } else if (item.linkopt == 3) {
        // 禁用点击直接返回
        console.log("点击事件已禁用");
      } else if (item.linkopt == 4) {
        // 快速支付
        _this.fastpayclick(item);
      } else if (item.linkopt == 5) {
        // 弹窗
        _this.popupbox(item);
      } else {
        // 其他情况判断次级
        _this.evenclickforlinkType(item);
      }
    },
    // 恢复弹窗点击
    handelRecoveryPopupClickBuy() {
      console.log(this.modelist[0]);
      this._sendTrack("click_buy_button", {
        campaign_id: this.markeyPage.combinationId,
        url: window.location.href,
        content_url: this.modelist[0].href,
        partner_id: this.markeyPage.partnerId,
        product_id: this.getStrParam("groupid", this.modelist[0].href),
        button_name: "购买按钮",
        sensors: "2",
      });
      this.ishandelRecoveryPopup = true;
      this.evenclick(this.modelist[0]);
    },
    // 关闭弹窗
    closeRecoveryPopup() {
      clearInterval(this.recoveryTimer);
      this._sendTrack("close_retention_popup", {
        view_duration: this.recoveryTime,
        campaign_id: this.markeyPage.combinationId,
        url: window.location.href,
        content_url: this.modelist[0].href,
        partner_id: this.markeyPage.partnerId,
        product_id: this.getStrParam("groupid", this.modelist[0].href),
      });

      this.isShowRecoveryPopup = false;
    },
    /**
     * @description: 处理
     * @param {*}url
     * @return {*} 返回新的url
     */
    resetutmcampaign(url, pay) {
      const _this = this;
      // 获取页面utm_campaign 传递给购买链接
      if (url != "") {
        // 获取url中的utm_campaign参数
        var utm_campaign = _this.getUrlParam("utm_campaign");
        const isPay =
          url.indexOf("buy.homeway.com.cn") > -1 ||
          url.indexOf("/pay/quickpay") > -1 ||
          pay;
        console.log("ispay", isPay, url, pay);
        console.log("isShowRecoveryPopup", this.isShowRecoveryPopup);
        console.log("recoveryPopupTimeOver", this.recoveryPopupTimeOver);
        console.log("recoveryPopupClickBuy", this.recoveryPopupClickBuy);
        console.log("ishandelRecoveryPopup", this.ishandelRecoveryPopup);
        if (isPay) {
          utm_campaign = this.formateRecoveryUrl("", utm_campaign);
        }
        // 获取url中的utm_source参数
        var utm_source = _this.getUrlParam("utm_source");
        // 获取url中的mark参数
        var mark = _this.getUrlParam("mark");
        // 获取url中的mark1参数
        var mark1 = _this.getUrlParam("mark1");
        // 获取url中的click_id参数
        var clickid = _this.getUrlParam("clickid");
        // 获取url中的domain
        var domain = url.split("?")[0] + "?";
        // 获取url中的advertiserId
        var advertiserId = _this.getUrlParam("advertiserId");
        // 获取url中的参数对象
        var urlobj = _this.urltourlparam(url);
        // 如果url中存在click_id参数，则替换为当前页面的click_id参数
        if (_this.getUrlParam("clickid") != null) {
          urlobj.clickid = clickid;
        }
        // 如果url中存在utm_campaign参数，则替换为当前页面的utm_campaign参数
        if (_this.getUrlParam("utm_campaign") != null) {
          urlobj.utm_campaign = utm_campaign;
        }
        // 如果url中存在utm_source参数，则替换为当前页面的utm_source参数
        if (_this.getUrlParam("utm_source") != null) {
          urlobj.utm_source = utm_source;
        }
        // 如果url中存在mark参数，则替换为当前页面的mark参数
        if (_this.getUrlParam("mark") != null) {
          urlobj.mark = mark;
        }
        // 如果url中存在mark1参数，则替换为当前页面的mark1参数
        if (_this.getUrlParam("mark1") != null) {
          urlobj.mark1 = mark1;
        }
        // 如果url中存在advertiserId参数，则替换为当前页面的advertiserId参数
        if (_this.getUrlParam("advertiserId") != null) {
          urlobj.advertiserId = advertiserId;
        }
        // 如果是homeway.com.cn域名，则删除utm_campaign、utm_source、mark、mark1参数
        if (url.indexOf("buy.homeway.com.cn") > -1) {
          // delete urlobj.utm_campaign;
          delete urlobj.utm_source;
          delete urlobj.mark;
          delete urlobj.mark1;
        }
        url = domain + _this.paramtourl(urlobj);
      }
      return url;
    },
    /**
     * @description: 验证是否买过套餐
     * @return {*}
     */
    verifyorder(groupid, item) {
      const _this = this;
      _this.isHasBeenPaid({
        groupid,
        isVerification: item.noRepeatPurchase,
        callback(res) {
          // 返回两个集合getpackageinfo:{},getuserordercount:{}
          if (res.getpackageinfo.respCode == "0") {
            // 已经判断完是否购买
            if (res.getuserordercount.respCode == "0") {
              // item.customerServiceUrl
              // 如果购买过则跳转客服 buytimes 产品股买次数
              if (
                res.getuserordercount.result.buytimes * 1 > 0 &&
                item.customerServiceUrl
              ) {
                _this.buyToCustom(item);
                _this._evenclicksendTrack(
                  { url: item.customerServiceUrl },
                  item,
                );
              } else {
                _this.ispayurl(item.href);
                _this._evenclicksendTrack({ url: item.href }, item);
              }
            } else {
              _this.ispayurl(item.href);
              _this._evenclicksendTrack({ url: item.href }, item);
            }
          } else {
            // 未能检测到是否购买，直接执行下一步
            _this.ispayurl(item.href);
            _this._evenclicksendTrack({ url: item.href }, item);
          }
        },
      });
      // _this.getData(
      //   _this.apilist("getpackageinfo"),
      //   function (res) {
      //     if (res.respCode == "0") {
      //       let arrparams = [];
      //       arrparams.push(groupid);
      //       // 是否有绑定套餐
      //       if (
      //         res.result.bindPackageVOList &&
      //         res.result.bindPackageVOList.length > 0
      //       ) {
      //         for (let i in res.result.bindPackageVOList) {
      //           arrparams.push(res.result.bindPackageVOList[i].groupID);
      //         }
      //       }
      //       // 获取N天前的日期
      //       let noRepeatPurchaseDays = item.noRepeatPurchaseDays;
      //       let gteFinishtimeUtx =
      //         new Date().getTime() - noRepeatPurchaseDays * 1000 * 24 * 60 * 60;
      //       _this.getData(
      //         _this.apilist("getuserordercount"),
      //         function (res) {
      //           if (res.respCode == "0") {
      //             // item.customerServiceUrl
      //             // 如果购买过则跳转客服 buytimes 产品股买次数
      //             if (res.result.buytimes * 1 > 0 && item.customerServiceUrl) {
      //               _this.buyToCustom(item);
      //               _this._evenclicksendTrack(
      //                 { url: item.customerServiceUrl },
      //                 item
      //               );
      //             } else {
      //               // setTimeout(function () {
      //               //   location.href = item.href;
      //               // }, 300)
      //               _this.ispayurl(item.href);
      //               _this._evenclicksendTrack({ url: item.href }, item);
      //             }
      //           } else {
      //             // setTimeout(function () {
      //             //   location.href = item.href;
      //             // }, 300)
      //             _this.ispayurl(item.href);
      //             _this._evenclicksendTrack({ url: item.href }, item);
      //           }
      //         },
      //         {
      //           productid: arrparams.toString(),
      //           orderStatus: 1,
      //           onlyCheckOrderIsExist: 1,
      //           gteFinishtimeUtx,
      //         },
      //         3000
      //       );
      //     } else {
      //       // setTimeout(function () {
      //       //   location.href = item.href;
      //       // }, 300)
      //       _this.ispayurl(item.href);
      //       _this._evenclicksendTrack({ url: item.href }, item);
      //     }
      //   },
      //   {
      //     groupid,
      //     getBindGroupInfo: 1,
      //   },
      //   3000
      // );
    },
    /**
     * @description: 获取短连接
     * @return {*}
     */
    setsorturl(item, localurl) {
      const _this = this;
      if (localStorage.getItem("urlparams") != null) {
        localurl =
          localurl.indexOf("?") > -1
            ? `${localurl}&${localStorage.getItem("urlparams")}`
            : `${localurl}?${localStorage.getItem("urlparams")}`;
      }
      localurl = _this.removeDuplicateParams(localurl);
      //   获取短连接
      $.ajax({
        url: _this.apilist("sorturl"),
        type: "get",
        dataType: "json",
        xhrFields: {
          withCredentials: true,
        },
        data: { url: encodeURI(localurl) },
      })
        .done(function (rs) {
          if (rs.code * 1 === 1) {
            _this.sorturl = rs.data;
            _this.postservicelink(item);
          } else {
            Indicator.close();
            MessageBox(rs.msg);
          }
        })
        .fail(function () {
          Indicator.close();
          console.log("error");
        })
        .always(function () {});
    },
    /**
     * @description: 获取获客助手链接
     * @return {*}
     */
    getAcquisitionRedirectionUrl(item) {
      const _this = this;
      let localurl = location.href;
      if (localStorage.getItem("urlparams") != null) {
        localurl =
          localurl.indexOf("?") > -1
            ? `${localurl}&${localStorage.getItem("urlparams")}`
            : `${localurl}?${localStorage.getItem("urlparams")}`;
      }
      const params = {
        acquisitionId: item.acquisitionId,
        reurl: encodeURIComponent(localurl),
      };
      if (item.userid * 1 > 0) {
        params.userid = item.userid;
        params.code = item.logincode;
      }
      //  获取获客助
      $.ajax({
        url: _this.apilist("getAcquisitionRedirectionUrl"),
        type: "post",
        dataType: "json",
        xhrFields: {
          withCredentials: true,
        },
        //contentType: "application/json;charset=utf-8",
        // data: {
        //   reurl:location.href
        // },
        data: params,
      })
        .done(function (rs) {
          Indicator.close();
          if (rs.code == 200) {
            if (rs.data) {
              console.log(_this.resetutmcampaign(rs.data), item, "rs.data");

              // 根据hkzs_showType决定处理方式
              if (item?.hkzs_showType === "qrcode") {
                // 显示二维码
                _this.showPaySuccess = false;
                _this.hkzsQrcodeData = _this.resetutmcampaign(rs.data);
                _this.getHkzsBackgroundOption(item);
                _this.$forceUpdate(); // 强制更新视图
              }
              // else if (item?.hkzs_showType === "load") {
              //   // 原有逻辑：跳转
              //   localStorage.removeItem("urlparams");
              //   setTimeout(function () {
              //     console.log(params);
              //     location.href = _this.resetutmcampaign(rs.data);
              //   }, 300);
              //   _this._evenclicksendTrack({ url: rs.data }, item);
              // }
              else {
                // 默认按原有逻辑处理（向后兼容）
                localStorage.removeItem("urlparams");
                setTimeout(function () {
                  console.log(params);
                  location.href = _this.resetutmcampaign(rs.data);
                }, 300);
                _this._evenclicksendTrack({ url: rs.data }, item);
              }
            } else {
              Indicator.open(`Error:获取获客助手失败`);
            }
          } else {
            Indicator.open(`Error:${rs.msg}`);
          }
        })
        .fail(function () {})
        .always(function () {});
    },

    /**
     * @description: 获取获客助手中配置的背景图片
     * @return {*}
     */
    getHkzsBackgroundOption(item) {
      const _this = this;
      console.log("getHkzsBackgroundOption", item.miniappModeId);
      _this.getData(
        _this.apilist("getmodelist"),
        (res) => {
          if (res.resultKey == "ok") {
            _this.hkzsBackgroundOption = res.data[0];
            console.log("hkzsBackgroundOption", res.data[0]);

            // 计算二维码位置和样式
            const qrcodeStyle = _this.calculateQrcodePosition(res.data[0]);
            _this.hkzsQrcodeStyle = {
              "background-image": `url(${res.data[0].src})`,
              ...qrcodeStyle,
            };
            _this.$forceUpdate(); // 强制更新视图
          }
        },
        { ids: item.miniappModeId },
      );
    },

    /**
     * @description: 计算二维码在不同屏幕下的适配位置
     * @param {*} backgroundOption 背景配置对象
     * @return {*} 返回计算后的样式对象
     */
    calculateQrcodePosition(backgroundOption) {
      // 设计稿尺寸
      const designWidth = 375;

      // 获取当前屏幕宽度
      // const screenWidth =
      //   window.innerWidth || document.documentElement.clientWidth;

      // 背景图片固定宽度（600rpx ≈ 300px）
      const bgImageWidth = 300;

      // 根据设计图375宽度获取比例（参考小程序代码）
      const aspectRatioW = parseInt(backgroundOption.position.W) / designWidth;
      const aspectRatioY = parseInt(backgroundOption.position.Y) / 650; // 假设设计稿高度650

      // 获取position配置
      const position = backgroundOption.position || {};
      console.log("原始position:", position);

      let qrcodeStyle = {};

      // 计算二维码宽度（参考小程序：aspectRatioW * rect.width）
      let qrcodeWidth = aspectRatioW * bgImageWidth;

      // 处理X位置（参考小程序逻辑）
      let qrcodeLeft;
      if (position.X === "" || position.X === "auto") {
        // 未指定宽度根据设计图比例转化X对象（居中）
        qrcodeLeft = bgImageWidth / 2 - qrcodeWidth / 2;
        qrcodeStyle["--qrcode-transform-x"] = "0";
      } else {
        // 根据设计图比例转化X对象
        qrcodeLeft = (parseInt(position.X) / designWidth) * bgImageWidth;
        qrcodeStyle["--qrcode-transform-x"] = "0";
      }

      qrcodeStyle["--qrcode-left"] = `${qrcodeLeft}px`;

      // 处理Y位置（需要等背景图片加载后才能准确计算，这里先用比例）
      // 这里假设背景图片的高度，实际应该在图片加载后动态计算
      const estimatedBgHeight = bgImageWidth * 1.5; // 假设高宽比1.5:1
      const calculatedTop = aspectRatioY * estimatedBgHeight;
      // 向上调整位置，减少30px让二维码位置更合适
      const qrcodeTop = calculatedTop - 30;
      qrcodeStyle["--qrcode-top"] = `${qrcodeTop}px`;

      // 二维码尺寸
      qrcodeStyle["--qrcode-width"] = `${qrcodeWidth}px`;
      qrcodeStyle["--qrcode-height"] = `${qrcodeWidth}px`; // 保持正方形

      console.log("背景图片宽度:", bgImageWidth);
      console.log("二维码样式:", qrcodeStyle);
      console.log("宽度比例:", aspectRatioW);
      console.log("高度比例:", aspectRatioY);

      return qrcodeStyle;
    },
    /**
     * @description: 背景图片加载完成后重新计算二维码位置
     * @param {*} event 图片加载事件
     * @return {*}
     */
    onBackgroundImageLoad(event) {
      const _this = this;
      console.log("背景图片加载完成，但不重新计算二维码位置");
      // 图片加载完成，但保持初始计算的位置和大小不变
      _this.$forceUpdate();
    },
    /**
     * @description:
     * @return {*}
     */
    followWechatPa(item) {
      item.type = "qrcode";
      // 如果已经计算过二维码位置，则不需要再重置
      if (item.position && item.position.W && item.position.W * 1 > 0) {
      } else {
        item.position = {
          H: "auto",
          W: 202,
          X: 106,
          Y: 228,
        };
      }
      item.src =
        "https://photo28.hexun.com/img/2025/0106/o_a8310c7c135b4700bf0f798c48223816.jpeg";
      item.qrsrc = item.followGzhUrl;
      $("#app").css({
        "background-image": `url(https://photo28.hexun.com/img/2025/0106/o_6bdc8caad29447c89eeba814a4ff2be2.png)`,
        "background-repeat-x": "no-repeat",
        "background-size": "100% auto",
      });
    },
    /**
     * @description: 检查支付状态
     * @param {*} item
     * @return {*}
     */
    checkPayStatus(item) {
      const _this = this;
      return new Promise((resolve) => {
        // 如果没有传入item参数，直接返回false
        if (!item) {
          resolve(false);
          return;
        }

        let isResolved = false; // 防止重复resolve

        // 设置3秒超时
        const timeoutTimer = setTimeout(() => {
          // 支付状态查询3秒超时，返回false
          if (!isResolved) {
            isResolved = true;
            clearInterval(checkTimer);
            console.log("支付状态查询3秒超时，返回false");
            resolve(false);
          }
        }, 3000);
        // 从 landingPage URL 中提取页面ID
        let bigdata = _this.getBrowserId();
        let id = new URL(item.landingPage).pathname
          .split("/")
          .pop()
          .split(".html")[0];
        const invoketoken = `${bigdata}_${id.slice(-9)}`;
        // 调用支付状态查询API
        const params = {
          invoketoken: invoketoken, // 订单标识
          needQueryOrderInfo: 1,
        };
        // 每500毫秒查询一次
        const checkTimer = setInterval(() => {
          // 如果已经resolved，停止查询
          if (isResolved) {
            clearInterval(checkTimer);
            return;
          }
          _this.getData(
            _this.apilist("getInvoketokenOrderPayed"),
            function (res) {
              // 如果已经resolved，不处理响应
              if (isResolved) return;
              if (res && res.respCode == 0) {
                // 0：未扫码，1：支付中，<订单号>：支付完成
                if (res.result && res.result.payResult * 1 > 1) {
                  // 支付完成
                  isResolved = true;
                  clearInterval(checkTimer);
                  clearTimeout(timeoutTimer);
                  console.log("支付状态查询成功：已支付");
                  resolve(true);
                } else if (res.result && res.result.payResult * 1 == 0) {
                  // 未扫码，继续查询
                  console.log("支付状态查询：未扫码，继续等待");
                } else if (res.result && res.result.payResult * 1 == 1) {
                  // 支付中，继续查询
                  console.log("支付状态查询：支付中，继续等待");
                }
              } else {
                // API调用失败，继续查询
                console.log("支付状态查询：API调用失败，继续尝试");
              }
            },
            params,
            2000, // 设置API超时时间为2秒
          );
        }, 500); // 每500毫秒查询一次
      });
    },
    /**
     * @description: 唤起客服
     * @return {*}
     */
    customerservice(item) {
      const _this = this;
      console.log("c", item);
      // 判断是否强制支付
      if (
        item.forcePay &&
        _this.modeopt?.payMentType == "h5RefundWithoutLogin"
      ) {
        // 检查是否支付完，500毫秒间隔查询订单信息
        this.checkPayStatus(item).then((isPaid) => {
          console.log(isPaid, "isPaid");
          if (isPaid) {
            _this.isPaid = true;
            console.log("支付成功，继续执行客服逻辑");
            // 支付成功，执行原有的客服逻辑
            _this.executeCustomerServiceLogic(item);
          } else {
            // 跳转到落地页
            //console.log(_this.resetutmcampaign(item.landingPage)
            window.location.href = _this.resetutmcampaign(item.landingPage);
          }
        });
      } else {
        // 不需要强制支付，直接执行客服逻辑
        _this.executeCustomerServiceLogic(item);
      }
    },
    /**
     * @description: 执行客服逻辑
     * @param {*} item
     * @return {*}
     */
    executeCustomerServiceLogic(item) {
      const _this = this;
      var utm_source = _this.getUrlParam("utm_source");
      utm_source =
        utm_source != null ? utm_source : _this.markeyPage.launchChannel;
      // 如果勾选了"微信渠道投放关注公众号"并且渠道是微信公众号
      if (item.followGzh && utm_source.indexOf("gzh") > -1) {
        _this.followWechatPa(item);
        return;
      }
      // 通过addWxOption判断是客服还是获客助手（客服 kf     微信客服-获客助手 kf_hkzs      获客助手hkzs 仅关注公众号gzh）
      if (item.addWxOption && item.addWxOption == "hkzs") {
        if (item.acquisitionId && item.acquisitionId * 1 > 0) {
          Indicator.open("正在连接客服...");
          const params = {
            Acs_Appid: "7518681818",
            Acs_Interfaceid: "2008396160",
          };
          _this.getData(
            _this.apilist("getuserid"),
            function (res) {
              if (res.code == 1) {
                // localurl = `${localurl}${location.href.indexOf("?") > -1 ? "&" : "?"
                //   }userid=${res.data.userId}&code=${res.data.code}`;
                item.userid = res.data.userId;
                item.logincode = res.data.code;
              }
              _this.getAcquisitionRedirectionUrl(item);
            },
            params,
          );
        } else {
          Indicator.close();
          Indicator.open(`Error:acquisitionId为空`);
        }
      } else if (item.addWxOption && item.addWxOption == "gzh") {
        _this.followWechatPa(item);
      } else if (item.addWxOption == "miniapp") {
        _this.linktominiprogram(item);
      } else if (item.addWxOption == "ewQrGroup") {
        // 企微活码组
        console.log("🚀🚀🚀", item);
        Indicator.open("正在连接客服...");
        const params = {
          Acs_Appid: "7518681818",
          Acs_Interfaceid: "2008396160",
        };
        _this.getData(
          _this.apilist("getuserid"),
          function (res) {
            if (res.code == 1) {
              // localurl = `${localurl}${location.href.indexOf("?") > -1 ? "&" : "?"
              //   }userid=${res.data.userId}&code=${res.data.code}`;
              item.userid = res.data.userId;
              item.logincode = res.data.code;
            }
            _this.getWeUserCodePoolRedirectionUrl(item);
          },
          params,
        );
      } else {
        // 微信客服
        Indicator.open("正在连接客服...");
        _this.getsorturl(item);
      }
    },
    /**
     * @description: 根据企微活码组id 获取地址
     * @return {*}
     */
    getWeUserCodePoolRedirectionUrl(item) {
      const _this = this;
      $.ajax({
        url: _this.apilist("getWeUserCodePoolRedirectionUrl"),
        type: "post",
        dataType: "json",
        xhrFields: {
          withCredentials: true,
        },
        //contentType: "application/json;charset=utf-8",
        data: {
          // 活码ID
          poolId: item.ewqr_id,
          //当前页面地址
          reurl: encodeURIComponent(location.href),
          // 用户id
          userid: item.userid,
          // code
          code: item.logincode,
        },
      })
        .done(function (rs) {
          if (rs.code == 200) {
            Indicator.close();
            console.log(rs);
            // 获取背景色
            _this.getHkzsBackgroundOption(item);
            // 设置二维码
            _this.ewqr_imgsrc = rs.data;
          } else {
            console.log(rs.msg);
          }
        })
        .fail(function () {
          console.log("error");
        })
        .always(function () {
          Indicator.close();
        });
    },
    /**
     * @description:获取userID传入接口
     * @return {*}
     */
    getsorturl(item) {
      const _this = this;
      if (_this.sorturl == null) {
        let localurl = location.href;
        if (item.userid * 1 > 0) {
          localurl = `${localurl}${
            location.href.indexOf("?") > -1 ? "&" : "?"
          }userid=${item.userid}&code=${item.logincode}`;
          _this.setsorturl(item, localurl);
        } else {
          const params = {
            Acs_Appid: "7518681818",
            Acs_Interfaceid: "2008396160",
          };
          _this.getData(
            _this.apilist("getuserid"),
            function (res) {
              if (res.code == 1) {
                localurl = `${localurl}${
                  location.href.indexOf("?") > -1 ? "&" : "?"
                }userid=${res.data.userId}&code=${res.data.code}`;
              }
              _this.setsorturl(item, localurl);
            },
            params,
          );
        }
      } else {
        _this.postservicelink(item);
      }
    },
    /**
     * @description: 请求客服地址
     * @return {*}
     */
    postservicelink(item) {
      const _this = this;
      $.ajax({
        url: _this.apilist("serviceurl"),
        type: "get",
        dataType: "json",
        xhrFields: {
          withCredentials: true,
        },
        //contentType: "application/json;charset=utf-8",
        data: {
          // 企业ID
          corpId: item.corpid,
          //客服ID
          openKfId: item.serviceid,
          // 场景
          scene: _this.sorturl,
        },
      })
        .done(function (rs) {
          if (rs.code == 200) {
            Indicator.close();
            let par =
              rs.data.indexOf("?") > -1
                ? `&scene_param=${_this.sorturl}`
                : `?scene_param=${_this.sorturl}`;
            let url = rs.data + par;
            localStorage.removeItem("urlparams");
            const ua = window.navigator.userAgent.toLowerCase();
            _this._evenclicksendTrack({ url: url }, item);
            if (ua.includes("micromessenger") && ua.includes("miniprogram")) {
              if (wx && wx.miniProgram && wx.miniProgram.redirectTo) {
                wx.miniProgram.redirectTo({
                  url: "/pages/service/index",
                });
              }
            } else {
              location.href = url;
            }
            _this.servicelist.push({
              url: rs.data,
              id: item.id,
            });
          } else {
            console.log(rs.msg);
          }
        })
        .fail(function () {
          console.log("error");
        })
        .always(function () {
          Indicator.close();
        });
    },
    /**
     * @description: 根据id获取数据
     * @param {*} id
     * @return {*}
     */
    getItem(id) {
      const _this = this;
      let item = "";
      for (let items of _this.modelist) {
        if (items.id === id) {
          item = items;
          break;
        }
      }
      return item;
    },
    /**
     * @description: 实时计算宽高
     * @param {*} item
     * @return {*}
     */
    getsit(item) {
      const _this = this;
      let style = "";
      if (item.fixed === "fixed-bottom") {
        style = `${style}position: fixed;bottom:0px;left:0px`;
        return style;
      }
      if (item.fixed === "fixed-top") {
        style = `${style}position: fixed;top:0px;left:0px`;
        return style;
      }
      if (item.type === "pic") {
        return;
      }
      if (item.type === "link" || item.type === "application") {
        let w = ((item.position.W * 1) / 414) * $(window).width();
        let h = ((item.position.H * 1) / 414) * $(window).width();
        const x = ((item.position.X * 1) / 414) * $(window).width();
        const y = ((item.position.Y * 1) / 414) * $(window).width();
        w = w == 0 ? "100%" : `${w}px`;
        h = h == 0 ? "60px" : `${h}px`;
        style = `position: absolute;width:${w};height:${h};left:${x}px;top:${y}px;z-index: 1;`;
        if (item.parentId != "") {
          setTimeout(function () {
            if (item.position.H * 1 == 0) {
              item.position.H = 20;
            }
            if (item.position.W * 1 == 0) {
              item.position.W = 414;
            }
            const obj = $(`#${item.parentId} img`)[0];
            const objitem = _this.getItem(item.parentId);
            if (
              obj &&
              obj.length > 0 &&
              typeof objitem.position != "undefined"
            ) {
              const difh = obj.height / objitem.position.H;
              const difw = obj.width / objitem.position.W;
              console.log(item.position.H * 1 * difh);
              style = `position: absolute;width:${
                item.position.W * 1 * difw
              }px;height:${item.position.H * 1 * difh}px;left:${
                item.position.X * 1 * difw
              }px;top:${item.position.Y * 1 * difh}px;z-index: 1;`;
              $(`#${item.id}`).attr("style", style);
            }
          }, 800);
        }
        return style;
      }
    },
    /**
     * @description: 根据miniappGroupId获取二维码
     * @param {*} miniappGroupId 小程序组ID
     * @return {Promise} 返回二维码URL的Promise
     */
    getQrCode(miniappGroupId) {
      const _this = this;
      return new Promise((resolve, reject) => {
        const params = {
          groupId: miniappGroupId,
          pageId: _this.id,
          unionid: _this.getCookie("hx_bigdata_uid"),
          userType: "t",
        };
        $.ajax({
          type: "get",
          url: _this.apilist("getQrCode"),
          data: params,
          dataType: "json",
          xhrFields: {
            withCredentials: true,
          },
          success: function (rs) {
            if (rs.code === 200 && rs.data) {
              resolve(rs.data);
            } else {
              reject(new Error(rs.msg || "获取二维码失败"));
            }
          },
          error: function (xhr, status, error) {
            reject(new Error("网络请求失败"));
          },
        });
      });
    },
    /**
     * @description: 读取接口处理数据存储到本地
     * @param {*} _data
     * @return {*}
     */
    async setmode(_data) {
      const _this = this;
      let arr = JSON.parse(JSON.parse(_data));
      let modelist = arr.modelist;
      let modeopt = arr.modeopt;
      let isMicroPayent = false;
      let groupId = 0;
      let conversionLinktype = "";
      _this.modelist = modelist.filter((item) => {
        item.userinfo = _this.userinfo;
        if (item && typeof item["href"] === "undefined") {
          item["href"] = "javascript:void(0)";
        }
        //item.miniappGroupId = 200
        // 如果type是qrcode，需要根据miniappGroupId获取二维码
        if (
          item?.type === "qrcode" &&
          item.miniappGroupId &&
          item.miniappGroupId * 1 > 0
        ) {
          item.qrsrc =
            "https://photo28.hexun.com/img/2025/0711/o_a367051082d349b5b9b0674ee9656a8d.png";
          // 根据miniappGroupId获取二维码
          _this
            .getQrCode(item.miniappGroupId)
            .then((res) => {
              item.qrsrc =
                res && res.qrCode
                  ? res.qrCode
                  : "https://test-photo28.hexun.com/img/2025/0709/o_b52df41cab7144e79ad8ab30397403e3.jpeg";
            })
            .catch((error) => {
              item.qrsrc =
                "https://test-photo28.hexun.com/img/2025/0709/o_b52df41cab7144e79ad8ab30397403e3.jpeg";
              console.log("获取二维码失败:", error);
            });
        }
        // 测试数据
        //item.payMentType = "h5LoginOrder"
        //item.conversionLinktype = "autoRefund"
        // item.src = 'https://test-photo28.hexun.com/img/2026/0104/o_3e4b413b920d4101b6e06eb830a1cd0b.png';
        // item.groupId = '16101724';
        // item.agreementText = "{500}元"
        // item.agreementBtnText="同意协议并且支付￥[price]"
        // item.linkopt = 4
        // item.payMentType = "h5RefundWithoutLogin"
        // item.payNum = 0.01
        //item.userAgreementPopup = "POPUP_4"
        /**
         * @description: 判断是否使用小于1元的新支付链路
         * @param {*} item.payMentType h5LoginOrder||h5RefundWithoutLogin 登录订单模式，免登录退款模式
         * @return {*} item.conversionLinktype  nomal（默认）  noRefund（不自动退款） autoRefund（自动退款）
         */
        // 在登录订单模式下并且 设置了不走默认路径，需要获取AB测试信息和订单信息
        if (
          item.payMentType &&
          item.payMentType == "h5LoginOrder" &&
          item.conversionLinktype &&
          item.conversionLinktype != "nomal"
        ) {
          // 获取订单信息
          isMicroPayent = true;
          _this.isMicroPayent = isMicroPayent;
        }
        conversionLinktype = item.conversionLinktype;
        if (item.groupId && item.groupId * 1 > 0) {
          groupId = item.groupId;
        }
        return item;
      });
      _this.modeopt = modeopt;
      _this.isShowRecoveryPopup = _this.modeopt.recoveryPopupStrategyEnabled;
      // 判断是支付逻辑并且开启了挽留流程
      const meeag =
        _this.modelist[0].href.indexOf("buy.homeway.com.cn") > -1 ||
        _this.modelist[0].payMentType == "h5RefundWithoutLogin";
      if (_this.modeopt.recoveryPopupStrategyEnabled && meeag) {
        // const _time = new Date().getTime();
        // _this.getAbTest({
        //     // 实验参数名称
        //     param_name: "wanliu",
        //     // 试验默认值
        //     default_value: "A",
        //     // 试验值类型
        //     value_type: "String",
        //     // 回调 返回值支持字符串、数字、布尔、对象、数组等类型,由产品在神策建立实验时确定
        //     callback: (result) => {
        //       // 请根据 result 进行自己的试验，当前试验对照组返回值为：a，试验组依次返回：b
        //       // 获取用户命中的试验结果，针对用户可能命中的试验进行处理
        //       if (new Date().getTime() - _time <= 1 * 1000) {
        //         console.log("返回实验分组:", result);
        //         if (result == "B") {
        // 开启了权限并且为B组，执行倒计时并且看是否点击了购买等按钮
        this.setRecoveryPopupTimeOut();
        //       }
        //     } else {
        //       console.log("返回实验分组:分组响应超过1秒,保持原方案");
        //     }
        //   },
        // })
      }
      // 如果是小于1元的支付,需要获取AB测试信息和订单信息
      if (isMicroPayent && groupId * 1 > 0) {
        // 获取订单金额是否是小于1元
        let detail = await _this.getOrderDetaile(groupId, true);
        // 判断实际价格需要等于1元
        let isMpay =
          detail.respCode == "0" &&
          detail.result &&
          detail.result.realPrice &&
          detail.result.realPrice * 1 <= 1
            ? true
            : false;
        // 是否需要做风控
        let needRiskControlManagement =
          detail.respCode == "0" &&
          detail.result &&
          detail.result.needRiskControlManagement
            ? true
            : false;
        // 如果是自动退费需要判断是否属于担保交易
        let belongEnsurePay =
          conversionLinktype == "autoRefund"
            ? detail.respCode == "0" &&
              detail.result &&
              detail.result.belongEnsurePay
              ? true
              : false
            : true;
        _this.modelist[0]._price =
          detail.respCode == "0" && detail.result && detail.result.realPrice
            ? detail.result.realPrice * 1
            : "";
        if (isMpay && belongEnsurePay && !needRiskControlManagement) {
          // 如果是小额支付，获取ab信息
          _this.isMicroPayent = (await _this.getMicroPayentAbtest())
            ? true
            : false;
          if (_this.isMicroPayent) {
            $("#appcss").remove();
            // 如果是短链路支付,需要设置快捷支付回调地址
            _this.modelist[0].fastpaybackurl =
              _this.modelist[0].customerServiceUrl;
            // 需要判断是否买过,落地页需要判断是否勾选了验证，支付过渡页需要验证
            if (_this.modelist[0].noRepeatPurchase) {
              let arrparams = [];
              arrparams.push(groupId);
              // 是否有绑定套餐
              if (
                detail.result.bindPackageVOList &&
                detail.result.bindPackageVOList.length > 0
              ) {
                for (let i in detail.result.bindPackageVOList) {
                  arrparams.push(detail.result.bindPackageVOList[i].groupID);
                }
              }
              // 是否买过
              _this.modelist[0]._isHasBeenPaidForGroup =
                await _this.getUserCount(arrparams);
            } else {
              _this.modelist[0]._isHasBeenPaidForGroup = false;
            }
          }
        } else {
          _this.isMicroPayent = false;
        }
      }
      // 获取运营后台模版队列
      _this.getadmodelist();
      _this.setopt();
      _this.isLoadedAll = true;
    },
    // 倒计时
    setRecoveryPopupTimeOut() {
      clearTimeout(this.recoveryPopupTimer);
      this.recoveryPopupTimer = setTimeout(() => {
        console.log("倒计时结束");
        this.recoveryPopupTimeOver = true;
      }, this.modeopt.recoveryPopupStayTime * 1000);
    },
    /**
     * @description: 处理配置参数
     * @param {*}
     * @return {*}
     */
    setopt() {
      const _this = this;
      $("#app").css({
        "background-color": _this.modeopt.backcolor,
        "background-image": `url(${_this.modeopt.backimg})`,
        "background-repeat-x": "no-repeat",
        "background-size": "100% auto",
      });
    },
  },
  // mounted
  mounted() {
    const _this = this;
    // 处理安卓点击input键盘失去焦点后页面不回落
    window.originalHeight =
      document.body.clientHeight || document.documentElement.clientHeight;
    window.onresize = function () {
      var resizeHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      if (resizeHeight < originalHeight) {
        $("body").height(window.originalHeight);
        //document.body.clientHeight = window.originalHeight;
      }
    };
    //  需要自动执行第一个模块点击事件
    if (_this.isjump) {
      Indicator.open();
    }
    //_this.$refs.weixin.init();
  },
};
</script>

<style lang="scss">
#app,
.main {
  width: 100%;
  height: 100%;
}

.main {
  position: relative;
  overflow-x: hidden;

  .item {
    width: 100%;
    pointer-events: auto;
    // 获客助手二维码样式
    .hkzs-qrcode {
      width: 100%;
      height: 100vh;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;

      .hkzs-qrcode-bg {
        position: relative;
        width: 300px; // 固定宽度（600rpx ≈ 300px）

        // 背景图片
        .bg-image {
          width: 100%;
          height: auto;
          display: block;
        }

        .qr-code-positioned {
          position: absolute;
          left: var(--qrcode-left, 50%);
          top: var(--qrcode-top, 200px);
          width: var(--qrcode-width, 210px);
          height: var(--qrcode-height, 210px);
          transform: translateX(var(--qrcode-transform-x, -50%));

          // 确保二维码SVG填充整个容器
          svg {
            width: 100% !important;
            height: 100% !important;
          }
        }
      }
    }

    .popupwx {
      width: 100%;
      height: 100%;
      position: fixed;
      left: 0;
      top: 0;
      background: rgba(0, 0, 0, 0.4);
      z-index: 3;
      display: flex;
      align-items: center;
      justify-content: center;

      .popupboxlay {
        width: 80%;
        position: relative;
        transform: translate(0px, -1000px);
        animation-name: fadeIn;
        animation-duration: 1s;
        /* 动画持续时间为2秒 */
        animation-delay: 0.5s;
        /* 动画将在5秒后开始 */
        animation-fill-mode: both;
        /* 动画结束后保持最后一个关键帧的状态 */
        animation-iteration-count: 1;

        /* 动画只播放一次 */
        @keyframes fadeIn {
          0% {
            opacity: 0;
          }

          100% {
            opacity: 1;
            transform: translate(0px, 0px);
          }
        }

        .popupclose {
          position: absolute;
          bottom: auto;
          width: 20px;
          height: 20px;
          right: 4px;
          top: 4px;
          left: auto;
        }
      }
    }

    .video {
      line-height: 0;

      .iframevideo {
        width: 100%;
        height: calc(100vw / 1.7777);
      }
    }

    .application {
      height: 100%;

      .applicform {
        height: 100%;

        .input {
          height: 33.3333%;
          display: flex;
          align-items: end;
          justify-content: center;

          input {
            width: 100%;
            height: calc(100vw / 10.35);
            box-sizing: border-box;
            padding: 0 10px;
            font-size: 14px;
            border-radius: 4px;
            background: #fff;
          }

          .inputsub {
            width: 60%;
            height: calc(100vw / 10.35);
            box-sizing: border-box;
            font-size: 14px;
            border-radius: 4px;
            background: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
    }

    .qrcode {
      width: 100%;
      position: relative;
      line-height: 0;

      .back {
        width: 100%;
        pointer-events: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        user-select: none;
      }

      .qr {
        position: absolute;
        border: #ee5050 6px solid;
        box-sizing: border-box;
      }
    }

    .pic {
      line-height: 0;
      width: 100%;
      pointer-events: auto;
      .img {
        width: 100%;
        pointer-events: none;
      }

      .pichref {
        width: 100%;
      }
    }

    .link {
      position: absolute;
      margin-top: 100px;
      left: 50%;
      transform: translate(-50%, 0);
      text-align: center;
      background: rgba(255, 255, 255, 0.95);
      border-radius: 12px;
      padding: 24px 32px;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
      backdrop-filter: blur(10px);
      border: 1px solid rgba(255, 255, 255, 0.2);
      min-width: 280px;
      animation: fadeInUp 0.6s ease-out;
    }

    .link p {
      margin: 0;
      line-height: 1.6;
    }

    .link p:first-child {
      color: #333;
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 8px;
    }

    .link p:last-child {
      color: #666;
      font-size: 14px;
      position: relative;
    }

    .link p:last-child::after {
      content: "";
      display: inline-block;
      width: 4px;
      height: 4px;
      background: #1890ff;
      border-radius: 50%;
      margin-left: 8px;
      animation: blink 1.4s infinite;
    }

    @keyframes fadeInUp {
      from {
        opacity: 0;
        transform: translate(-50%, 20px);
      }
      to {
        opacity: 1;
        transform: translate(-50%, 0);
      }
    }

    @keyframes blink {
      0%,
      50% {
        opacity: 1;
      }
      51%,
      100% {
        opacity: 0.3;
      }
    }

    .phone {
      width: 100%;
      background: #f4f4f4;
      overflow: hidden;

      .phoneitem {
        overflow: hidden;
        display: flex;
        align-items: center;
        margin: 24px auto;
        width: 84%;
        background: #fff;
        border-radius: 4px;
        font-size: 18px;
        padding: 0 16px;

        .n {
          width: 30%;
          text-align: right;
        }

        input {
          width: 70%;
          font-size: 18px;
          height: 50px;
          line-height: 50px;
          border: 0px;
          box-shadow: hidden;
        }
      }

      .pho_x1 .n {
        text-align: left;
      }

      .pho_x3 .n {
        line-height: 0;
      }

      .pho_x3 img {
        width: 100%;
      }

      .pho_x2 {
        .red {
          color: #ee5050;
        }
      }

      .pho_x4 {
        width: 93%;
        margin: 0 auto;
        padding: 0 0 20px 0;
        line-height: 0px;

        img {
          width: 100%;
        }
      }

      .pho_x5 {
        padding: 0 0 20px 0;
        width: 100%;
        display: inline-flex;
        align-items: center;
        justify-content: center;

        label {
          display: inline-flex;
          align-items: center;
        }

        input {
          width: 14px;
          height: 14px;
          margin: 0 4px;
        }

        a {
          color: #0054a6;
          margin: 0 2px;
        }
      }
    }
  }
}

.compass {
  line-height: 0;
  position: relative;

  .layimg {
    width: 100%;
  }

  .zhzback {
    position: absolute;
    display: flex;
    justify-content: center;
    bottom: 110px;
    width: 100%;

    .zhzimg {
      width: 50%;
      box-shadow: 0 0 40px 20px #fff;
      border-radius: 50%;
    }

    .zhzgroup {
      position: absolute;
      text-align: center;
      top: -10%;

      .zhzgroupimg {
        width: 60%;
        animation: zhzgroupimg 20s linear infinite;
      }

      .zhzcent {
        position: absolute;
        text-align: center;
        top: 45%;
        width: 100%;
      }

      .zhzcentimg {
        width: 38%;
        animation: zhzgroupimg 3s linear infinite;
      }
    }
  }
}

.popformlay {
  background: #fff;
  border-radius: 4px;

  padding: 20px 4%;

  .contion {
    color: #ee5050;
    padding: 0;
    font-size: 12px;
    text-align: center;
  }

  .formbtn {
    width: 40%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border-radius: 10px;
    background: rgba(233, 17, 17);
    color: #fff;
    margin: 10px auto 0;
    font-size: 18px;
    font-weight: bold;
  }

  .item {
    display: flex;
    margin-bottom: 10px;
    align-items: center;

    .item-l {
      width: 30%;
      padding-right: 3%;
      box-sizing: border-box;
      text-align: right;
    }

    .item-l::before {
      content: "*";
      color: #ee5050;
      display: inline-flex;
      align-items: center;
      padding: 0 4px;
      justify-content: center;
    }

    .item-r {
      flex: 1 auto;

      input,
      .el-select {
        -webkit-appearance: none;
        background-color: #fff;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        height: 32px;
        line-height: 32px;
        outline: 0;
        padding: 0 15px;
        transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
        width: 100%;
      }
    }
  }
}

.zpopformlay .item .item-l {
  width: 45%;
}

@keyframes zhzgroupimg {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
.h5LoginFreeBox {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  .freelayout {
    margin: 0 auto;
    width: 90%;
    position: relative;
    .img {
      display: block;
      margin: 0 auto;
      background-size: 100% auto;
      background-repeat: no-repeat;
    }
    .floatlay {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
    }
    .term {
      width: 222px;
      color: #ee3129;
      margin: 0 auto;
      display: flex;
      a {
        color: #ee3129;
        text-decoration: underline;
        font-size: 12px;
      }
      input[type="checkbox"] {
        width: 14px;
        height: 14px;
        vertical-align: middle;
        margin-right: 4px;
        border: 1px solid #ee3129;
        position: relative;
      }
      input[type="checkbox"]::after {
        content: "";
        display: block;
        width: 13px;
        height: 13px;
        border: 1px solid #ee3129;
        background: #fff;
        border-radius: 1px;
        position: absolute;
        left: -1px;
        top: -1px;
      }
      input[type="checkbox"]:checked::after {
        display: none;
      }
    }
    .btn {
      height: 120px;
      display: block;
      width: 100%;
      background-size: 100% auto;
      background-repeat: no-repeat;
    }
  }
}
.h5LoginFreeBox.POPUP_1 {
  .freelayout {
    .floatlay {
      height: 112px;
    }
    .img {
      background-image: url(https://photo28.hexun.com/img/2025/0725/o_050c0f10309344e89dcf90034e45f99e.png);
      width: 320px;
      height: 420px;
    }
    .btn {
      background-image: url(https://photo28.hexun.com/img/2025/0725/o_c214c72caaf54e86866fa7e53bc655be.png);
      width: 190px;
      height: 42px;
      margin: 6px auto 0;
    }
  }
}
.h5LoginFreeBox.POPUP_2 {
  .freelayout {
    .floatlay {
      height: 152px;
    }
    .term {
      color: #ee3129;
      width: 250px;
      a {
        color: #ee3129;
        font-size: 14px;
      }
    }
    .img {
      background-image: url(https://photo28.hexun.com/img/2025/0725/o_66caae9ab4894e039484d0deec9df397.png);
      width: 320px;
      height: 386px;
    }
    .btn {
      background-image: url(https://photo28.hexun.com/img/2025/0725/o_a0701469cdc24f37b4e37e8729db5427.png);
      width: 222px;
      height: 46px;
      margin: 20px auto 0;
    }
  }
}
.h5LoginFreeBox.POPUP_3 {
  .freelayout {
    .floatlay {
      height: 136px;
    }
    .term {
      color: #feeabf;
      width: 250px;
      a {
        color: #feeabf;
        font-size: 14px;
      }
      input[type="checkbox"]::after {
        border: 1px solid #feeabf;
        background: #e7282c;
      }
    }
    .img {
      background-image: url(https://photo28.hexun.com/img/2025/0725/o_596bb29d21974f50950195a636c0f6d7.png);
      width: 320px;
      height: 418px;
    }
    .btn {
      background-image: url(https://photo28.hexun.com/img/2025/0725/o_9b4cdbe5e0534425a5eaa77e7a719a28.png);
      width: 274px;
      height: 56px;
      margin: 10px auto 0;
    }
  }
}
.h5LoginFreeBox.POPUP_4 {
  .freelayout {
    .floatlay {
      height: 202px;
    }
    .term {
      color: #feeabf;
      width: 250px;
      a {
        color: #feeabf;
        font-size: 14px;
      }
      input[type="checkbox"]::after {
        border: 1px solid #feeabf;
        background: #e7282c;
      }
    }
    .img {
      background-image: url(https://photo28.hexun.com/img/2025/0725/o_497ad2cc9158469ea1bbcc491aef0ad6.png);
      width: 320px;
      height: 436px;
    }
    .btn {
      background-image: url(https://photo28.hexun.com/img/2025/0725/o_e326a629745f43ad856600077b050185.png);
      width: 274px;
      height: 70px;
      margin: 6px auto 0;
    }
  }
}
.recovery_popup {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  position: absolute;
  top: 0;
  left: 0;
  .recovery_popup_box {
    width: 343px;
    height: 400px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: url("~@/assets/images/shadow.png") no-repeat center -21px;
    background-size: 263px 153px;
  }
  .recovery_popup_close {
    position: absolute;
    bottom: -20px;
    border: 1px solid #fff;
    border-radius: 50%;
    height: 20px;
    width: 20px;
  }
  .recovery_popup_content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: url("~@/assets/images/recovery_popup.png") no-repeat center 90px;
    background-size: 291px auto;
  }
  .recovery_popup_title_wrap {
    top: 33px;
    display: inline-block;
    position: relative;
    overflow: visible; /* 必须 */
    line-height: 36px;
  }
  .recovery_popup_title_left_bg {
    width: 30px;
    height: 30px;
    background: url("~@/assets/images/recovery_title_right.png") no-repeat
      center;
    position: absolute;
    left: -34px;
    top: 4px;
    background-size: 100%;
  }
  .recovery_popup_title_right_bg {
    width: 30px;
    height: 30px;
    background: url("~@/assets/images/recovery_title_left.png") no-repeat center;
    position: absolute;
    right: -34px;
    top: 4px;
    background-size: 100%;
  }

  /* 阴影层（正常文字，不做裁剪） */
  .recovery_popup_title_shadow {
    position: absolute;
    top: 4px; /* 阴影下移 */
    left: 0;
    font-size: 26px;
    font-weight: 600;
    color: rgba(232, 92, 46, 0.45); /* 阴影颜色 */
    z-index: 0;
  }
  /* 上层渐变文字（经过 background-clip） */
  .recovery_popup_title {
    background: linear-gradient(90deg, #fff 0%, #f2d7b3 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: 26px;
    font-weight: 600;
    position: relative;
    z-index: 1;
  }

  .recovery_popup_value {
    position: absolute;
    height: 136px;
    text-align: center;
    top: 90px;
    width: 100%;
    color: #f15000;
    font-size: 17px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: pre-wrap;
  }
  .recovery_popup_fixed_title {
    position: absolute;
    top: 211px;
    color: #fff;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  .recovery_popup_fixed {
    top: 344px;
    position: absolute;

    color: #fff;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  .recovery_popup_button_text {
    background: linear-gradient(90deg, #eb3129 0.24%, #ab342f 88.3%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .recovery_popup_button {
    position: absolute;
    top: 255px;
    padding: 5px 10px;
    border-radius: 18px;
    background: linear-gradient(90deg, #ffedb4 0%, #fff3cc 50%, #fbdf89 100%);
    color: #fff;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    .tuijian {
      position: absolute;
      right: -13px;
      top: -15px;
      width: 48px;
      height: 20px;
      background: #ff8a31;
      border-radius: 10px 10px 10px 0;
      font-size: 12px;
      text-align: center;
      line-height: 20px;
    }
  }
}
.supplementary_text_important {
  font-size: 24px;
  font-weight: 600;
}
</style>
